{
  "404": {
    "title": "Page not found... 👀",
    "subtitle": "Please make sure the link you are trying to access is correct."
  },
  "LANDING": {
    "nav": {
      "calendar": "Calendar",
      "bookingPage": "Online Booking",
      "pricing": "Pricing"
    },
    "landing": {
      "metaTitle": "Free appointment scheduling system - Improve Your Business Efficiency & Boost Sales With Automated Marketing Tools",
      "pageTitle": "The Ultimate Booking Software",
      "pageDescription": "Elevate your barbershop and salon experience with 24/7 appointment booking and automated text reminders to reduce no-shows for your clients",
      "tagline": "Free appointment scheduling system",
      "taglineBarbers": "Free appointment scheduling system for barbers",
      "taglineSalon": "Free appointment scheduling system for beauty salons",
      "taglineNails": "Free appointment scheduling system for Nail Artists",
      "taglineMakeup": "Free appointment scheduling system for Makeup Artists",
      "taglineSpa": "Free appointment scheduling system for Spa's",
      "taglineGym": "Free appointment scheduling system for gyms and personal trainers",
      "taglinePts": "Free appointment scheduling system for Personal Trainers",
      "taglinePhysio": "Free appointment scheduling system for physiotherapists",
      "taglinePsy": "Free appointment scheduling system for psychologists",
      "taglineNutri": "Free appointment scheduling system for nutritionists",
      "taglineDentist": "Free appointment scheduling system for dental clinics",
      "taglinePharma": "Free appointment scheduling system for pharmacies",
      "taglineTherapy": "Free appointment scheduling system for therapy centers",
      "taglineOsteo": "Free appointment scheduling system for osteopaths",
      "taglineHomeo": "Free appointment scheduling system for homeopaths",
      "taglineReiki": "Free appointment scheduling system for reiki masters",
      "taglineAcu": "Free appointment scheduling system for acupuncture",
      "featuresPanel8": {
        "text": "View More"
      },
      "stats": {
        "title1": "+20 million",
        "text1": "processed appointments",
        "title2": "+3 million",
        "text2": "customers booked with BUK",
        "title3": "+4,000",
        "text3": "businesses using it daily",
        "title4": "+12,000",
        "text4": "professionals"
      },
      "how-to": {
        "pill1": "TAKE CONTROL",
        "title1": "Your Bookings at Your Fingertips",
        "text1": "Take control of your schedule anywhere, anytime. Simplify business management like never before!",
        "pill2": "OPTIONAL",
        "title2": "Say Goodbye </br>to Missed Calls",
        "text2": "Personalize your Booking Page </br>to reflect your brand!"
      },
      "noCreditCardNeeded": "No credit card required.",
      "terms": "Terms and conditions",
      "privacy": "Privacy policy",
      "cookies": "Cookies policy",
      "cookiesCta": "View cookies policy",
      "help": "Do you have questions?",
      "faqs": "FAQs",
      "login": "Log In",
      "promoCopy": "Pro Plan 3x1 - Get 3 months, pay 1!",
      "heroPromoBadge": "3 months Pro for the price of 1",
      "cancelAnytime": "Cancel anytime",
      "noCreditCard": "No credit card required.",
      "googleRating": {
        "score": "4.9",
        "reviews": "450+ reviews"
      },
      "registerCta": "Sign Up for Free",
      "registerCta2": "Sign up",
      "signupCtaAd": "Sign Up",
      "contactCta": "Book Demo",
      "headerDescription": "With your own-branded booking page your clients can easily see if you're available and make appointments on the fly. BUK is quickly accessible from your social pages (Facebook, Instagram ...) and can dramatically improve brand loyalty.",
      "featuresTitle": "Manage and Grow Your Business!",
      "featuresTitleBarber": "Manage and Grow Your Barbershop!",
      "featuresTitleSalon": "Manage and Grow Your Salon!",
      "featuresTitleNails": "Manage and Grow Your Beauty Salon!",
      "featuresTitleMakeup": "Manage and Grow Your Beauty Salon!",
      "featuresTitleSpa": "Manage and Grow Your Beauty Salon!",
      "featuresTitleGym": "Manage and Grow Your Workouts!",
      "featuresTitlePts": "Manage and Grow Your Workouts!",
      "featuresTitlePhysio": "Manage and Grow Your Physiotherapy's center!",
      "featuresTitlePsy": "Manage and Grow Your Appointments!",
      "featuresTitleNutri": "Manage and Grow Your Appointments!",
      "featuresTitleDentist": "Manage and Grow Your Dental Clinic!",
      "featuresTitlePharma": "Manage and Grow Your Pharmacy!",
      "featuresTitleTherapy": "Manage and Grow Your Therapy center!",
      "featuresTitleOsteo": "Manage and Grow Your Osteopathic Clinic!",
      "featuresTitleHomeo": "Manage and Grow Your Homeopathic clinic!",
      "featuresTitleReiki": "Manage and Grow Your Reiki appointments!",
      "featuresTitleAcu": "Manage and Grow Your Acupuncture and Traditional Chinese Medicine appointments!",
      "footerLinksPrefix": "Online Bookings for",
      "features": {
        "calendarTitle": "Online Calendar",
        "calendarText": "Take full control of your online calendar and effortlessly manage appointments. Keep your clients informed with unlimited automatic text and email reminders.",
        "bookingTitle": "Booking page",
        "bookingText": "Your logo, your colors, your image. Customize your booking page to suit your brand's look.",
        "teamTitle": "Team Management",
        "teamText": "Efficiently manage your team's schedule, or have them manage their own with ease. Distribute bookings according to your customers' preferences.",
        "smsTitle": "Text reminders",
        "smsText": "Unlock efficiency with automated texts and email reminders, ensuring your clients never miss an appointment again.",
        "statsTitle": "Statistics",
        "statsText": "Monitor Your Business Performance.",
        "bookingsTitle": "Bookings 24/7",
        "bookingsText": "Easily schedule and secure appointments at any time and stay in the loop with real-time updates and notifications.",
        "marketing2Title": "Marketing",
        "marketing2Text": "Keep your customers coming back with targeted text and email campaigns, alongside irresistible special offers",
        "mbway2Title": "Online Payments",
        "mbway2Text": "Empower your clients to pay in advance while booking appointments, preventing last-minute cancellations at no extra cost. Accept credit cards, Apple Pay, and Google Pay.",
        "google2Title": "Google Reviews",
        "google2Text": "Encourage client reviews on Google, enhancing your Google listing and elevating your business's visibility.",
        "loyaltyTitle": "Loyalty Program",
        "loyaltyText": "Create a loyalty program with rewards to encourage your best clients to return.",
        "crmTitle": "Custom CRM",
        "crmText": "Add custom fields to the booking page to collect important information and improve service.",
        "pixelTitle": "Google & Meta Conversions",
        "pixelText": "Analyze the impact of your campaigns with integrated Google and Meta pixels."
      },
      "testimoniesTitle": "Our Customers Love Us ❤️",
      "testemonies": {
        "testemonyBento": "BUK allows my customers to conveniently schedule the services they desire. This greatly facilitates our work.",
        "testemonyAnton": "BUK is easy to use, highly interactive, practical, and functional. It allows working in a more organized and professional manner.",
        "testemonyLigia": "Joining BUK was one of the best decisions I made professionally. I save hours of work per week, and my clients love the fact that they can book appointments independently.",
        "testemonyPraga": "BUK is the platform that has assisted me the most in my work to date. It is simple, intuitive, and highly customizable for every business. I highly recommend it! As for the clients, it is very easy to use"
      },
      "businessesTitle": "Choose your business and start for free!",
      "everyBusiness": "A Calendar for All Types of Businesses",
      "blog": "Our blog",
      "reachOut": "Reach us out at",
      "businesses": {
        "barber": "Barbershops",
        "barbers": "Barber",
        "salon": "Salon",
        "salons": "Hair stylist",
        "nails": "Nail artist",
        "nailss": "Nail Artists",
        "makeup": "Makeup artist",
        "makeups": "Makeup artists",
        "fitness": "Fitness",
        "fisio": "Physiotherapists",
        "osteo": "Osteopaths",
        "dentist": "Dentist",
        "dentists": "Dental Clinic",
        "psy": "Psychologists",
        "psys": "Psychologist",
        "beauty": "Beauty",
        "sports": "Sports",
        "gyms": "Gyms",
        "pts": "Personal trainers",
        "health": "Health",
        "pharma": "Pharmacy",
        "pharmacies": "Pharmacies",
        "therapy": "Therapy centers",
        "alternativeTherapies": "Alternative therapies",
        "osteopathy": "Osteopathy",
        "homeopathy": "Homeopathy",
        "reiki": "Reiki",
        "acupuncture": "Acupuncture",
        "nutri": "Nutritionists",
        "nutricionists": "Nutritionists",
        "others": "Others"
      },
      "ctaSection": {
        "title": "Join Over 4000 Businesses",
        "text": "Receive appointments 24/7 through your personalized booking page. Wave goodbye to no-shows with automated text reminders!"
      },
      "footerText1": "BUK © a brand of ",
      "footerText2": "built in Portugal",
      "refText1": "invited you to BUK",
      "refText2": "You have a 50% discount on professional plans!",
      "refText3": "With this invite from"
    },
    "landCalendar": {
      "hero": {
        "title": "Your calendar on your pocket!",
        "desc": "Access your calendar anytime, anywhere. Managing your business has never been easier!"
      },
      "feat1": {
        "title": "Customize your calendar to fit your business reality",
        "check1": "Set your working hours and block breaks and lunchtime",
        "check2": "Option for daily or weekly view",
        "check3": "Set the advance notice for customer bookings (made by your clients)",
        "check4": "Hide employee view on days off"
      },
      "feat2": {
        "title": "Unlimited and Customizable Text/Email Reminders",
        "check1": "Add a personal touch to your communications with your clients",
        "check2": "Write your own text messages and choose the sender's name",
        "check3": "Add important information in booking emails"
      },
      "feat3": {
        "title": "Business Statistics",
        "desc": "Access important information to grow your business:",
        "check1": "Number of bookings",
        "check2": "Most requested services by clients",
        "check3": "Billing data by store and employee",
        "check4": "Number of visits to the booking page"
      },
      "feat4": {
        "title": "Access Your Clients' Profiles with a Click",
        "desc": "Access important information about your clients for a unique experience:",
        "check1": "Contact information, birthdate, and notes",
        "check2": "Client statistics (number of bookings, no-shows, cancellations, amount spent)",
        "check3": "Booking history and last visit",
        "check4": "Favorite services"
      },
      "feat5": {
        "title": "Managing Your Team Has Never Been Easier!",
        "check1": "Track the calendar and productivity of all employees",
        "check2": "Different schedules and services per employee",
        "check3": "Customize your calendar with colors for each service"
      },
      "feat6": {
        "title": "Exclusive access for your employees",
        "desc": "Limit access to the calendar with different permissions:",
        "check1": "Administrator",
        "check2": "Manager",
        "check3": "Employee"
      },
      "feat7": {
        "title": "Birthday Text Messages",
        "desc": "Stay connected with your clients and send them birthday messages."
      },
      "feat8": {
        "title": "Text/Email Marketing",
        "check1": "Create campaigns and promotions to bring back your clients",
        "check2": "Filter clients for personalized messages",
        "check3": "Use our automatic templates and send a promotion in just a few seconds"
      },
      "featIntegratedInvoicing": {
        "title": "Integrated invoicing",
        "desc": "Issue legally valid invoices in Portugal without leaving BUK.",
        "check1": "Issue invoices from a booking or sales record",
        "check2": "Send by email or download the PDF in seconds",
        "check3": "Integration with AT-certified invoicing software"
      },
      "featSalesCommissions": {
        "title": "Sales and commission management",
        "desc": "Record service and product sales and track payments in one place.",
        "check1": "Record sales in the app or on your phone",
        "check2": "Track unpaid and paid statuses in real time",
        "check3": "Set commissions per team member"
      },
      "featRoomsEquip": {
        "title": "Room and equipment management",
        "desc": "Organize room and equipment availability in your calendar.",
        "check1": "Room view with occupied and free time slots",
        "check2": "Avoid double-booking the same space",
        "check3": "Link rooms to services and team members"
      }
    },
    "landBookingPage": {
      "hero": {
        "title": "No More Missed Calls",
        "desc": "Customize your booking page and share the link with your clients. Making a booking has never been so simple!"
      },
      "feat1": {
        "title": "Your brand",
        "desc": "Customize Your Booking Page with Your Logo and Brand.",
        "check1": "Receive bookings 24/7",
        "check2": "Share your booking link with all your clients"
      },
      "feat2": {
        "title": "Custom Booking Process",
        "check1": "Customizable booking links for each store / employee",
        "check2": "Set the advance notice for customer bookings, e.g., 8 hours, 16 hours, 24 hours",
        "check3": "Allow clients to book multiple services in a single booking",
        "check4": "Request pre-payment at the time of booking and prevent no-shows"
      },
      "feat3": {
        "title": "Online Payments",
        "desc": "Choose and Configure Various Payment Methods like Credit Card, Apple Pay, and Google Pay.",
        "check1": "Prevent no-shows with online pre-payment",
        "check2": "Set up online prepayment with a deposit or full payment"
      },
      "feat4": {
        "title": "Boost Your Google Reviews",
        "check1": "Increase your business visibility on Google Maps",
        "check2": "Send an automated message to your clients with a direct link to Google reviews"
      },
      "feat5": {
        "title": "Stay Connected with Your Clients Easily",
        "desc": "Add your booking link on all platforms: Facebook, Instagram, Google Maps, WhatsApp",
        "check1": "Reduce phone calls while you work",
        "check2": "Devote more time to what really matters: your clients",
        "check3": "Analyze conversions through your Google/Meta Pixel"
      },
      "feat6": {
        "title": "Loyalty Program",
        "desc": "Offer rewards to loyal clients and encourage their next visit.",
        "check1": "Set the reward and the number of visits required to earn it",
        "check2": "Customize your program's terms and conditions",
        "check3": "Strengthen relationships with your best clients"
      },
      "feat7": {
        "title": "Custom Fields for Your Business",
        "desc": "Personalize the booking page and client profile with fields specific to your business.",
        "check1": "Add Text, Date, or Dropdown fields",
        "check2": "Choose whether fields are required or optional for online bookings"
      },
      "feat8": {
        "title": "Your Custom QR Code",
        "desc": "Simplify access to your schedule with a practical QR code.",
        "check1": "Enable quick bookings with a simple scan on cards or flyers",
        "check2": "Place the QR code at the entrance to give your business a modern, accessible touch"
      }
    },
    "pricing": {
      "h1": "Plans & Pricing",
      "subtext": "You can cancel or change your subscription at any time.",
      "perMonth": "/ month",
      "byProvider": "per extra staff member",
      "freeDescription": "Enjoy a free digital calendar to manage your business.",
      "proPlanDescription": "More features, no surprises, and unlimited e-mail and text reminders!",
      "proPlanDescriptionNoSMS": "More features and unlimited e-mail reminders!",
      "proPlusDescription": "Customization and integration options for your ideal scheduling solution",
      "payAnnual": "Pay yearly",
      "unlimitedSMS": "Unlimited Text reminders",
      "features": {
        "bookingPage": "Booking page",
        "advancedBookingPage": "Personalized Booking page",
        "calendar": "Online Calendar",
        "advancedCalendar": "Advanced Online Calendar",
        "advancedSettings": "More settings and customisation",
        "email": "Unlimited email reminders",
        "email100": "Email reminders (100 free/month)",
        "stats": "Business Statistics",
        "googleCalendar": "Google Calendar Sync",
        "sms": "Text reminders",
        "smsEmailUnlimited": "Unlimited e-mail/Text reminders",
        "unlimited": "Unlimited Text reminders",
        "whatsapp": "Priority WhatsApp support",
        "one_provider": "Only 1 staff member",
        "contact": "Get a quote",
        "all_pro": "Everything in the Pro plan",
        "birthday": "Birthday Texts",
        "marketingTools": "Marketing Tools",
        "personalizedReminders": "Personalized reminders",
        "marketingCredit": "5$ Monthly credit for marketing",
        "marketingCredit2": "50% discount on marketing tools",
        "apiAccess": "API access",
        "loyalty": "Loyalty Program",
        "websiteIntegration": "Website integration",
        "integratedInvoicing": "Integrated invoicing",
        "googleReserve": "Google Reserve",
        "googleReviews": "Google Reviews",
        "viewMore": "View complete list",
        "viewLess": "View less"
      },
      "enterprise": "Enterprise",
      "enterpriseLabel": "+20 providers",
      "enterpriseDesc": "A custom price, a more personalised and integrated solution. Work with use to create the ideal booking solution for your kind of business.",
      "registerBusiness": "Sign Up for Free",
      "yearly": "Yearly",
      "monthly": "Monthly",
      "payed_yearly": "Monthly amount / Paid yearly",
      "vat_included": "VAT included",
      "vat_not_included": "VAT not included",
      "morePopular": "Most popular",
      "everythingFromFree": "Everything from Free",
      "tryPro": "1 month free with promo code: TRYPRO",
      "vatDisclaimer": "Have part-time collaborators? Contact us and we'll make a discount on your monthly fee. The prices shown are subject to the applicable VAT rate.",
      "withoutCommitment": "No commitment"
    },
    "recover-pass-page": {
      "h3": "Recover password",
      "newPassword": "New password",
      "confirmPassword": "Confirm password",
      "passwordsInvalid": "The passwords are not the same",
      "login": "Login",
      "submit": "Submit",
      "emailSent": "An email has been sent with instructions on how to recover your password",
      "passwordSuccess": "The password has been changed successfully"
    },
    "set-password-page": {
      "h3": "Create account",
      "newPassword": "New password",
      "confirmPassword": "Confirm password",
      "passwordsInvalid": "The passwords are not the same",
      "login": "Login",
      "submit": "Enter",
      "passwordSuccess": "You account has been successfully created"
    },
    "privacy": {
      "title": "Privacy Policy"
    },
    "unsubscribe": {
      "title": "Do you wish to unsubscribe this mailing list?",
      "cta": "Confirm",
      "successMessage": "Confirmed"
    },
    "terms": {
      "title": "Terms and Conditions"
    },
    "faqs": {
      "title": "Frequently Asked Questions",
      "q1": "What is BUK for?",
      "a1": "BUK allows your customers to book appointments anywhere, at any time, without the need to phone, email, or text you.",
      "q2": "How do I install BUK?",
      "a2": "There is nothing to install. BUK is web-based, allowing your customers to access it on any device, including mobile phones.",
      "q3": "How long does it take to get started?",
      "a3": "It takes about 5 minutes to get started. It's that simple.",
      "q4": "What information do I need to get started?",
      "a4": "You'll need information such as your business location, operating hours, staff names and schedules, and the services you offer.",
      "q5": "Is BUK only for barbershops?",
      "q5b": "Is BUK only for",
      "a5": "Absolutely not! BUK is suitable for any business that needs to schedule appointments. It is used daily by beauty salons, SPAs, personal trainers, physiotherapists, and many more professionals.",
      "q6": "Do I need a website to take advantage of BUK?",
      "a6": "No, you don't. Upon creating an account, you'll receive a public BUK link that you can share with your customers on social media.",
      "q7": "Can you help me set up BUK?",
      "a7": "Certainly. If you need help setting up BUK or have any other questions, feel free to get in touch <a href=\"mailto:support@buk.app\">here</a>.",
      "q8": "Do you have a mobile app?",
      "a8": "While BUK doesn't have a mobile app, it uses the latest web technologies, allowing access on any device. Users can also add your booking page to their mobile home screen for app-like performance.",
      "q9": "Can my customers pay with BUK?",
      "a9": "No, BUK focuses on providing a streamlined booking experience. We send text and email confirmations and reminders to ensure your customers don't miss their appointments.",
      "q10": "Can I use BUK to manage a large staff?",
      "a10": "Yes, you can add as many providers as you need. Each provider will have their own calendar and can set up their own schedule.",
      "q11": "We have multiple locations. Can I use BUK?",
      "a11": "Yes, you can manage multiple locations by adding them to your dashboard. Each location can have its own staff and schedule settings.",
      "q12": "How much does BUK cost?",
      "a12": "BUK is free for one employee. The PRO version costs $24.99 for the first employee and an additional $18 per month for each new employee. It includes features like email and unlimited text reminders, Google Calendar sync, and more.",
      "q13": "How much does it cost to add a second location?",
      "a13": "To add an extra location, you'll need to activate the PRO subscription.",
      "q14": "Is there a risk that multiple customers can book the same service at the same time?",
      "a14": "No, once a customer completes the booking process, BUK locks that time slot. However, you can make any changes to your schedule as needed.",
      "q15": "Do I have to confirm bookings made by my customers?",
      "a15": "No, bookings are automatically confirmed and managed by BUK. We do require customers to provide their contact information for easy rescheduling, if needed.",
      "q16": "Will BUK work with my website or Facebook profile?",
      "a16": "Yes, you can integrate BUK with your website using our WordPress plugin. For Facebook and other social media, simply follow our <b><a href=\"https://blog.buk.pt/o-seu-link-buk-pagina-de-marcacoes/\" target=\"_blank\">guide</a>.</b>.",
      "q17": "What happens if I need to close my business for a while or go on vacation?",
      "a17": "You can block time slots on your calendar to make them unavailable for booking.",
      "q18": "Can I schedule a recurring booking for my customers?",
      "a18": "Yes, you can set up recurring appointments by selecting the 'Repeat Appointment' option during the booking process.",
      "q19": "Does BUK send customers reminders of their upcoming appointments?",
      "a19": "Yes, BUK sends reminders 24 hours before the appointment via text and email.",
      "q20": "Can I reschedule an appointment if I have an emergency?",
      "a20": "Yes, you can easily reschedule appointments using BUK's calendar dashboard. We require customers to provide their contact information for this purpose.",
      "q21": "Do I have to define the price of my services?",
      "a21": "No, defining the price of your services is optional. If you leave the price field empty, it won't be displayed on the booking page.",
      "q22": "Can I set different working hours for my team?",
      "a22": "Yes, each employee can have different working hours. You can edit this information at any time.",
      "q23": "Can I add a 'Book Now' button to my Facebook page?",
      "a23": "Yes, you can add a 'Book Now' button to your Facebook page by editing the CTA button and linking it to your BUK page."
    }
  },
  "CLIENT": {
    "clientCancelBooking": {
      "wishToDelete": "Do you wish to cancel this appointment?",
      "cannotCancelOnline": "It's no longer possible to cancel this appointment online",
      "contactMerchantToCancel": "To cancel, please contact the merchant.",
      "contactMerchantPhone": "Phone:",
      "cancelledWithSuccess": "Appointment cancelled successfully.",
      "ctaCancelBooking": "cancel appointment",
      "ctaNewBooking": "new appointment",
      "paidRefundNote": "The refund of the paid payment is not automatic. You should contact the business owner."
    },
    "clientConfirm": {
      "title": "Confirm appointment",
      "namePlaceholder": "First and last name",
      "invalidPhoneNumber": "Please, fill in your phone number",
      "invalidPtNumber": "The MBway payment is only available for portuguese numbers (+351)",
      "emailPlaceholder": "Your email",
      "invalidEmail": "Please, fill in your email",
      "vatNumberPlaceholder": "VAT number",
      "invalidVatNumber": "Please, fill in your Vat number",
      "genderPlaceholder": "Gender",
      "dobPlaceholder": "Birthday",
      "invalidDob": "Invalid Birthday",
      "notesPlaceholder": "Write a note, e.g. any specific requirements.",
      "paymentMoney": "Pay later",
      "mbwayNotification1": "You will receive a notification to make a",
      "mbwayNotification2": "payment of",
      "mbwayNotification3": "corresponding to the services you selected.",
      "mbwayNotificationDeposit": "corresponding to the deposit.",
      "mbNotification": "Generate MB payment reference (valid for {{time}})",
      "requiredField": "Required.",
      "ctaConfirmBooking": "Confirm",
      "ctaPayBooking": "Pay",
      "termsConditions1": "I've read and agree with BUK's",
      "termsConditions1General": "I've read and agree with the",
      "termsConditions1b": "I've read and agree with AFFLELOU's",
      "termsConditions2": "Terms and Conditions",
      "termsConditions3": "and",
      "termsConditions3b": ".",
      "termsConditions4": "Privacy Policy",
      "termsConditions4b": ".",
      "termsConditions5": "of",
      "marketingCheckbox": "I agree to receive commercial information and promotions tailored to my profile and interests.",
      "marketingCorporateCheckbox": "I agree to receive commercial communications relating to optics or audiology products and services tailored to my profile, as well as about promotions, events or new products and services.",
      "termsConditionsCorporate1": "I have read and accept the Privacy Policy",
      "termsConditionsCorporate2": "and the Terms and Conditions",
      "paymentMethod": "Choose a payment method",
      "creditCard": "Credit Card",
      "depositBooking": "Deposit",
      "bookingDataTitle": "Booking data",
      "phoneOtpTitle": "Security code",
      "phoneOtpSent": "Enter the 6-digit code we sent by SMS to {{phone}}.",
      "phoneOtpPlaceholder": "SMS code",
      "phoneOtpInvalid": "Enter the 6-digit code",
      "phoneOtpConfirm": "Confirm",
      "phoneOtpResend": "Resend code",
      "phoneOtpResendIn": "Resend code in {{seconds}}s",
      "phoneOtpChangeNumber": "Change number",
      "phoneOtpCancel": "Cancel"
    },
    "clientDay": {
      "title": "Select a date",
      "seeMoreDates": "See more available dates",
      "noMoreAvailableDates": "No more available dates",
      "morning": "Morning",
      "afternoon": "Afternoon",
      "evening": "Evening",
      "noAvailability": "No availability for this month.",
      "viewNextMonth": "View next month"
    },
    "clientPage": {
      "newBooking": "New appointment",
      "cancelBooking": "Cancel appointment",
      "seoTitle": "Online Bookings",
      "seoDescription": "Simple and quick way to book your appointment.",
      "footer1": "Free appointment scheduling system",
      "footer2": "for all businesses",
      "canceled": "Canceled",
      "noshow": "No Show",
      "see": "See",
      "close": "Close"
    },
    "clientProviders": {
      "title": "Select a staff member",
      "title_multi": "Select a staff member for each of the services",
      "withoutPreference": "No preference"
    },
    "clientServices": {
      "title": "Select a service",
      "title_multi": "Select the services",
      "readMore": "Read more"
    },
    "clientStores": {
      "title": "Select an option"
    },
    "clientSuccess": {
      "title": "Confirm appointment",
      "thankYou": "Thank you!",
      "addToGoogleCalendar": "Add to Google Calendar",
      "addToCalendar": "Add to Outlook/Apple Calendar",
      "linkToIcal": "Subscribe to your calendar in Outlook, Apple Calendar",
      "mbwayTitle": "Approve the payment in the MBWay app",
      "mbwaySuccess": "We'll send you a confirmation e-mail after your payment has succeeded.",
      "mbwaySuccessPayOnly": "We'll send you a confirmation e-mail after your payment has succeeded.",
      "mbwaySuccessAlert": "In case your payment don't succeed your appointment will be canceled.",
      "mbSuccessAlert": "In case the payment doesn't go through in the next {{time}}",
      "mbSuccessAlert2": "this booking won't be succeded.",
      "mbSuccessStripeAlert": "This reference is valid until:",
      "viewPrintableVoucher": "View/Print Voucher",
      "newBooking": "New booking"
    },
    "clientPayBooking": {
      "alreadyPaid": "The booking is already paid"
    },
    "clientTime": {
      "title": "Select a time",
      "morning": "Morning",
      "afternoon": "Afternoon",
      "night": "Night"
    },
    "clientEditor": {
      "back": "Calendar",
      "share": "Share",
      "edit": "Edit",
      "preview": "Preview",
      "bookingPage": "Booking Page",
      "online": "Online",
      "offline": "Offline",
      "pageOffline": "Your page is offline",
      "pageOfflineText1": "When in Offline mode, your clients won't be able to access your booking page.",
      "pageOfflineText2": "Don't want to receive bookings through your booking page?",
      "pageOfflineText3": "No worries! You can set your booking page to Offline and still manage your business internally using the calendar.",
      "pageOfflineText4": "Going on vacation and don't want to receive bookings temporarily?",
      "pageOfflineText5": "You don't need to go Offline. Instead, you can create a Time Block in your calendar for that duration to prevent new bookings.",
      "personalize": "Personalize",
      "moreOptions": "More Options",
      "titleLabel": "Page title",
      "titleMandatory": "The page title is required",
      "bookingPageLink": "Booking page link",
      "linkPlaceholder": "Booking Link",
      "invalidLink": "Invalid link",
      "unavailableLink": "Unavailable",
      "availableLink": "Available",
      "yourQRCode": "Your QR Code",
      "yourQRCodeText": "Make it easy for customers to find you by displaying a personalized QR code at your front door.",
      "downloadQRCode": "Download",
      "personalizeWithYourBrand": "Personalize with your brand",
      "yourLogo": "Add your logo",
      "removeLogo": "Remove",
      "logoFormat": "Logo Format: jpg, png (min. 640x640px)",
      "coverImage": "Cover image",
      "useDefaultCover": "Use default",
      "imageFormat": "Image Format: jpg, png (min. 1200x600px)",
      "showTitleOverCoverImage": "Show title over cover image",
      "bookingInstructions": "Booking Instructions",
      "showBookingInstructions": "Show booking instructions",
      "font": "Title Font",
      "backgroundColor": "Background color",
      "footerNote": "Footer notes",
      "websiteAndSocialMedia": "Website & Social media",
      "facebookPage": "Facebook page",
      "facebookPageError": "Please enter a valid facebook link (ie: https://facebook.com/username/)",
      "instagramPage": "Instagram page",
      "instagramPageError": "Please enter a valid instagram link (ie: https://instagram.com/username/)",
      "websiteLink": "Your website",
      "optionsText": "Match your business needs",
      "allowProviderChoice": "Allow your clients to select their preferred staff member",
      "allowProviderChoiceText": "If you have multiple staff members, let your clients choose who they'd like to work with.",
      "allowRandomProviders": "Allow random staff selection",
      "allowRandomProvidersText": "Offer your clients the 'No preference' option, and let our system match them with a randomly assigned staff member.",
      "serviceCategoryExpanded": "Service categories display options",
      "serviceCategoryExpandedText": "Customize whether your service categories are expanded or collapsed by default.",
      "mandatoryEmailOnBooking": "Mandatory e-mail requirement",
      "mandatoryEmailOnBookingText": "Request your clients to provide an email address during the appointment booking process.",
      "showVatNumberOnBookingPage": "Enable VAT Number Inclusion",
      "showVatNumberOnBookingPageText": "Allow your clients to add their VAT number while booking an appointment.",
      "showGenderOnBookingPage": "Enable Gender Field",
      "showGenderOnBookingPageText": "Allow your clients to add their gender while booking an appointment.",
      "showDOBOnBookingPage": "Enable Birthday Field",
      "showDOBOnBookingPageText": "Allow your clients to add their birthday while booking an appointment.",
      "facebookTrackingPixelOrToken": "Facebook tracking",
      "facebookTrackingPixelOrTokenText": "Enhance your insights by adding your Facebook tracking pixel and Conversion API token (optional) to track your conversions.",
      "facebookPixelId": "Facebook Pixel ID",
      "facebookPixelIdError": "Please enter a valid Facebook Pixel ID.",
      "facebookConversionToken": "Facebook Conversion API token",
      "facebookConversionTokenError": "Please type a valid Facebook Conversion API token, it should be an alphanumeric value",
      "gaPropertyIdBox": "Google Analytics (GA4)",
      "gaPropertyIdBoxText": "Use your Google Analytics tracking code to capture online booking traffic data in your Google Analytics account.",
      "gaPropertyId": "Tracking ID",
      "gaPropertyIdError": "Please enter a valid Google Analytics 4 (GA4) Measurement ID in the format G-XXXXXXXX.",
      "gtmPropertyIdBox": "Google Tag Manager (GTM)",
      "gtmPropertyIdBoxText": "Use your Google Tag Manager container ID to track booking page traffic and conversions in your GTM setup.",
      "gtmPropertyId": "Container ID",
      "gtmPropertyIdError": "Please enter a valid Google Tag Manager (GTM) Container ID in the format GTM-XXXXXXX.",
      "tiktokPixelBox": "TikTok Pixel",
      "tiktokPixelBoxText": "Use your TikTok Pixel ID to capture booking page traffic and conversion data in your TikTok Ads account.",
      "tiktokPixelId": "TikTok Pixel ID",
      "tiktokPixelIdError": "Please enter a valid TikTok Pixel ID (uppercase alphanumeric).",
      "saveSuccess": "Saved successfully",
      "confirmClose": "You have unsaved changes. Do you really want to exit without saving?",
      "backToEditor": "Back to editor",
      "close": "Close",
      "shareOn": "Share on",
      "copyShareLink": "Copy Share Link",
      "linkCopied": "Copied",
      "shareText": "Book your next appointment with us in just a few clicks! Check out our booking page:",
      "shareReferralLink": "Your referral link",
      "shareReferralVia": "Share with your contacts"
    }
  },
  "CORE": {
    "seo": {
      "title": "BUK | Online Booking Calendar",
      "description": "Simple and flexible online appointments for your clients."
    }
  },
  "SHARED": {
    "setupStoreProducts": {
      "guidanceTitle": "Create and customize your products.",
      "addNew": "New Product",
      "editProducts": "Edit Products",
      "productName": "Product Name",
      "invalidproductName": "Invalid product name",
      "descriptionName": "Product Description",
      "invalidDescription": "Write a description for the product with a maximum of 500 characters",
      "invalidPrice": "Choose a price",
      "vatRate": "VAT Rate",
      "vatRatePlaceholder": "Select VAT Rate",
      "invalidVatRate": "Invalid VAT Rate",
      "confirmTextproduct": "Are you sure you want to delete this product?",
      "vatExemption": "VAT Exemption",
      "invalidVatExemption": "Please select a VAT exemption",
      "emptyState": "Add a product to get started."
    },
    "setupStoreRooms": {
      "guidanceTitle": "Create and customize your rooms or equipment.",
      "emptyState": "Add a room or equipment to get started.",
      "addNew": "New Room",
      "editRooms": "Edit Rooms",
      "roomName": "Room Name",
      "invalidRoomName": "Invalid room name",
      "descriptionName": "Room Description",
      "invalidDescription": "Invalid description",
      "confirmTextRoom": "Are you sure you want to delete this room?",
      "room": "Room",
      "equipment": "Equipment",
      "services": "Associated Services",
      "type": "Type",
      "typePlaceholder": "Room or equipment",
      "servicesPlaceholder": "Select services"
    },
    "close": "Close",
    "help-modal": {
      "title": "Need help?",
      "phone": "Phone",
      "sms": "Text",
      "wecanhelp": "Talk with us.",
      "helpCenter": "BUK Help Center"
    },
    "signup": {
      "missingEmail": "Please provide your email",
      "aboutBusiness": "About your business",
      "registerSubTitle": "The information of your business can be changed later in your account settings.",
      "yourAccount": "Your account",
      "yourBusiness": "Your business",
      "yourBusinessTitle": "Register your business in less then 1 minute",
      "writeYourName": "Fill in your name",
      "yourName": "First and last name",
      "writeYourEmail": "Fill in your email",
      "writeYourPhone": "Fill in your phone number",
      "writePassword": "Fill in your password",
      "readTerms1": "I've read and agree with BUK's",
      "readTerms2": "Terms and Conditions",
      "readTerms3": "and",
      "readTerms4": "Privacy Policy",
      "register": "Create",
      "alreadyHaveAnAccount": "Do you have an account already?",
      "loginHere": "Login here.",
      "newCompaniesCampaingCheckboxTitle": "New Companies",
      "newCompaniesCampaingDesc": "Use the Pro/Pro+ plan for free if you registered your company less than 3 months ago.",
      "newCompaniesCampaingCheckbox": "I want to apply for the BUK New Companies campaign"
    },
    "signup2": {
      "registerAccountSubtitle": "and setup your business in seconds!",
      "registerBusinessTitle": "Register your business",
      "registerBusinessSubtitle": "Welcome",
      "orUseEmail": "or use your e-mail",
      "logout": "Logout"
    },
    "login": {
      "login": "Login",
      "emailPlaceholder": "Email",
      "emailInvalidMessage": "Fill in your email.",
      "passwordPlaceholder": "Password",
      "passwordInvalidMessage": "Fill in a valid password.",
      "ctaLogin": "Login",
      "passwordNotRemember": "Have you forgotten your password?",
      "clickHere": "Go here.",
      "notRegisteredYet": "You don't have an account yet?",
      "signupHere": "Signup here."
    },
    "setupMerchantPage": {
      "businessName": "Business name",
      "invalidBusinessName": "Please, fill in your business name",
      "slug": "Booking link",
      "invalidSlug": "Invalid link",
      "teamSize": "What's your team size?",
      "teamSizeText": "Help us to improve your experience 🪄",
      "invalidBusinessType": "Please, fill in your business type",
      "unavailableLink": "Unavailable",
      "availableLink": "Available",
      "chooseCountry": "Choose your country",
      "country": "Country",
      "businessType": "What's your business type?",
      "businessTypeText": "Help us to improve your experience 🪄",
      "invalidTeamSize": "Invalid team size",
      "previousSoftware": "What software are you currently using?",
      "previousSoftwareText": "If you are thinking about switching, we can help accelerate the setup of your business and import your data into your new BUK account.",
      "discoverChannel": "Where did you hear about BUK?",
      "discoverChannelText": "Help us improve your experience",
      "otherSoftware": "Other",
      "noSoftware": "I don't use any software",
      "friend": "Recommended by a friend",
      "madeBooking": "Used it to make a booking",
      "search": "Google search",
      "social": "Instagram / Facebook",
      "ad": "In an online ad",
      "other": "Other"
    },
    "setupStoreServices": {
      "guidanceTitle": "Add your services:",
      "chooseCurrency": "Choose a currency",
      "serviceName": "Service name",
      "serviceImage": "Service image",
      "image": "Image",
      "changeColor": "Change color",
      "descriptionName": "Description",
      "invalidServiceName": "Please, fill in the service name",
      "invalidDescription": "Please, fill in the description with max 500 chars",
      "name": "Name",
      "description": "Description",
      "duration": "Duration",
      "customDuration": "Custom duration",
      "invalidDuration": "Please, fill in the service duration",
      "invalidPrice": "Please, fill in the service price",
      "color": "Color",
      "categoryName": "Separator name",
      "invalidCategoryName": "Please, fill in the separator name",
      "addNew": "New Service",
      "addNewCategory": "New Separator",
      "editCreateServices": "Edit Service",
      "editCreateCategory": "Edit Separator",
      "confirmTextService": "Are you sure you want to delete this service?",
      "confirmTextCategory": "Are you sure you want to delete this separator?",
      "showOnBookingPage": "Available on booking page",
      "showPriceOnBookingPage": "Show price on booking page",
      "generateVideoCallLink": "Generate video call link",
      "generateVideoCallLinkDescription": "Automatically create a Google Meet link to use with bookings of this service.",
      "scheduleOverride": "Set a custom schedule",
      "durationExtraConfig": "Customize duration for this service",
      "durationForClient": "Duration for customer",
      "durationForProvider": "Duration for provider",
      "options": "Options",
      "priceChange": {
        "title": "Choose an option",
        "description": "There are {{count}} future bookings for this service that haven't been paid yet. Do you want to apply the new price?",
        "newOnly": "No, apply only to new bookings",
        "alsoFuture": "Yes, apply to new and existing bookings"
      }
    },
    "setupStoreWorkplan": {
      "guidanceTitle": "Set up your business opening hours.",
      "openHour": "Open",
      "closeHour": "Close",
      "invalidCloseHour": "Fill in your close time",
      "invalidOpenHour": "Fill in your open time",
      "intervalsOverlap": "Time ranges on the same day cannot overlap.",
      "deleteHours": "Delete",
      "addHours": "Add",
      "mon": "Mon",
      "tue": "Tue",
      "wed": "Wed",
      "thu": "Thu",
      "fri": "Fri",
      "sat": "Sat",
      "sun": "Sun",
      "providerWorkplanConflict": "Please notice: This team member has a different schedule than the one defined for your store. To use the store's timetable click ",
      "here": "here",
      "storeWorkplanConflictSingular": "Warning: you have {{param}} team member with a different schedule from your store. Changes made on this page won't affect his/her schedules.",
      "storeWorkplanConflict": "Warning: you have {{param}} team members with different schedules from your store. Changes made on this page won't affect their schedules.",
      "storeServiceWorkplanConflictSingular": "Warning: you have {{param}} service with a different schedule from your store. Changes made on this page won't affect that service.",
      "storeServiceWorkplanConflict": "Warning: you have {{param}} services with different schedules from your store. Changes made on this page won't affect those services.",
      "createExceptions": "Create special schedules"
    },
    "setupStoreProviders": {
      "guidanceTitle": "Add your staff members.",
      "addNew": "Add new",
      "directLink": "Link",
      "nameResource": "Staff member name",
      "invalidNameResource": "Please, fill in the staff member name",
      "settings": "Choose staff member's workplan and services",
      "newProvider": "New staff member",
      "editProvider": "Edit staff member",
      "providerNoServicesError": "Please, select at least one service for this staff member",
      "goBack": "Go back",
      "addExistingProvider": "Add staff member from an existing store",
      "pickAnOption": "Choose an option",
      "sharedProviderWarning": "is associated with multiple Stores. Scheduling an appointment in one calendar will prevent booking in the others.",
      "noProvidersToAdd": "There are no more staff members left to add."
    },
    "setupProviderWorkplanModal": {
      "guidanceTitle": "Set a schedule for \"{{name}}\" different from the store's operating hours",
      "guidanceTitleNoName": "Choose the staff member's working hours.",
      "schedule": "Working hours"
    },
    "setupProviderServicesModal": {
      "guidanceTitle": "Select/Edit this provider's services",
      "guidanceTitleNoName": "Choose the staff member's services",
      "schedule": "Services",
      "scheduleOverride": "Set a custom schedule",
      "bookingFrequencyOverride": "Custom time slot interval for this provider",
      "bookingFrequencyBookingPageOnly": "This setting only affects the booking page.",
      "bookingFrequencyStoreDefaultHint": "When disabled, uses the store default ({{value}}).",
      "commissions": "Commissions"
    },
    "setupProviderCommissionsModal": {
      "guidanceTitle": "Select/Edit this provider's commissions",
      "guidanceTitleNoName": "Choose the staff member's commissions"
    },
    "googleConnectAccount": {
      "syncWithGoogleCalendar": "Google Calendar",
      "syncWithGoogleCalendarDescription": "Your appointments will automatically appear on your Google calendar.",
      "syncWithGoogleCalendarError": "Error trying to sync with google calendar. Please try again.",
      "syncedWith": "Sync with {{email}}",
      "sync": "Sync",
      "stopSync": "Stop sync"
    },
    "googleConnectReview": {
      "modalTitle": "Connect business",
      "searchLabel": "Find your business on Google Maps:",
      "testLink": "Test link",
      "saveLink": "Save"
    },
    "googleReserve": {
      "title": "Google Reserve",
      "desc": "Attract more clients by enabling direct bookings through Google Maps.",
      "cta": "Configure",
      "price": "$4.99/month",
      "freeUntil": "Free until 10/2023",
      "activate": "Activate extension",
      "deactivate": "Deactivate extension",
      "active": "Active",
      "inactive": "Inactive",
      "notBeauty": "Extension only available for beauty businesses",
      "askForHelp": "Ask for help",
      "success": "Extension activated! Please note, it may take up to 48 hours for this to take effect.",
      "warning": "Attention, some services are not available on Google Reserve due to the absence of configured prices.",
      "error": "Attention! To activate the extension, you need to set a price for your services. After configuration, the extension may take up to 48 hours to take effect.",
      "modalConfirmDeactivate1": "Attention! By deactivating this feature, you are losing a critical tool for your business.",
      "modalConfirmDeactivate2": "Your customers will not be able to schedule appointments through integration with Google Maps.",
      "modalConfirmActivate1B": "This extension has a monthly cost of $4.99/month.",
      "modalConfirmActivate1": "You can activate or deactivate it at any time with no commitment.",
      "modalConfirmActivate2": "Free until 10/2023 🥳",
      "modalConfirmActivate2desc": "No charges until October 1, 2023. You can cancel at any time by deactivating the extension.",
      "continue": "Continue",
      "goBack": "Go back"
    },
    "googleReviews": {
      "title": "Google Reviews",
      "desc": "Send an automatic message to your customers to leave a review on Google after their visit",
      "cta": "Configure",
      "price": "$4.99/month",
      "freeUntil": "Free until 10/2023",
      "activate": "Activate extension",
      "deactivate": "Deactivate extension",
      "active": "Active",
      "inactive": "Inactive",
      "success": "Extension activated!",
      "modalConfirmDeactivate1": "Attention! By deactivating this feature, you are losing a critical tool for your business.",
      "modalConfirmDeactivate2": "Your customers will not receive an automatic messageto leave a review on Google after their visit.",
      "modalConfirmActivate1B": "This extension has a monthly cost of $4.99/month.",
      "modalConfirmActivate1": "You can activate or deactivate it at any time with no commitment.",
      "modalConfirmActivate2": "Free until 10/2023 🥳",
      "modalConfirmActivate2desc": "No charges until October 1, 2023. You can cancel at any time by deactivating the extension.",
      "continue": "Continue",
      "goBack": "Go back"
    },
    "websiteIntegration": {
      "title": "Website Integration (Embed)",
      "desc": "Add an appointment section directly on your website with our embed code.",
      "cta": "Configure"
    },
    "loyaltyPage": {
      "title": "Loyalty Program",
      "desc": "Retain your customers through a points/visits tracking system and promotional offers",
      "desc2": "Attention, this loyalty program is activated independently for each store.",
      "cta": "Configure",
      "inactive": "Inactive",
      "success": "You are now on the waiting list. We will contact you when this feature becomes available.",
      "termsPlaceholder": "The loyalty program is open to all customers who use our services. Participation is voluntary, and the program can be changed or terminated at any time without prior notice.\n\nRewards are given based on the number of visits or bookings made. Cancellations or no-shows without prior notice will not be considered for the program. The company reserves the right to adjust the conditions in case of abuse.\n\nRewards must be claimed within a maximum of 60 days after they are awarded and used according to the rules defined by the company. Any misuse or use beyond the deadline may result in the loss of accumulated rewards.",
      "visits": "Visits",
      "visit": "Visit",
      "active": "Active",
      "deactivate": "Deactivate",
      "cancel": "Cancel",
      "terms": "Terms and conditions",
      "invalidTerms": "Invalid terms and conditions",
      "configuration": "Settings",
      "configurationDesc": "Configure your loyalty plan according to your business",
      "invalidValue": "Invalid value",
      "prizeName": "Prize name",
      "defaultName": "50% discount",
      "invalidName": "Invalid name",
      "faqs": "Frequently Asked Questions",
      "faqs_q1": "How does the Loyalty Program work?",
      "faqs_r1": "The Loyalty Program automatically tracks each completed visit by your clients. When the client reaches the number of visits required for the reward, they receive an email congratulating them, along with instructions on how to claim the reward on their next visit.",
      "faqs_q2": "What happens if the client misses the appointment?",
      "faqs_r2": "If the client does not show up – mark <No Show> on the appointment, and this visit will not be counted in the loyalty program. Only visits not marked as <No Show> count towards the progress.",
      "faqs_q3": "How can the client track their progress in the program?",
      "faqs_r3": "After each visit, the client receives an email with the number of visits completed so far, so they can easily track their progress towards the reward.",
      "faqs_q4": "How does the client receive the reward?",
      "faqs_r4": "When the client reaches the required number of visits to earn the reward, they receive an email congratulating them, along with the details of the reward.",
      "faqs_q5": "How to identify reward appointments in the back office?",
      "faqs_r5": "In the back office, appointments that include rewards are marked with a trophy icon, making them easy to identify. For regular appointments, you can also see the client's visit count, also marked by a trophy icon.",
      "faqs_q6": "What to do if the client doesn't receive the follow-up email?",
      "faqs_r6": "If the client does not receive the follow-up email after their visit, we suggest checking their spam or junk folder. If the issue persists, contact our support team.",
      "visitsDesc": "On which visit does the customer receive the prize?",
      "prizeNameDesc": "E.g. \"Free service\", \"€10 Voucher\"",
      "termsDesc": "This field is used to clearly communicate the rules of your loyalty program to your customers. Read carefully and adapt as necessary.",
      "cancelModalTitle": "Deactivate Loyalty Program",
      "cancelModalDesc1": "Attention! By deactivating, you are interrupting the reward system for your customers.",
      "cancelModalDesc2": "All your progress will be paused, and your visits will not be counted in the Loyalty Program. Don't forget to inform your customers.",
      "successModalTitle": "Great! The Program has been activated.",
      "successModalDesc1": "Now, each visit will be recorded in the Loyalty Program. You can track the progress through the customer profiles or the bookings made.",
      "successModalDesc2": "After each visit, the customer receives an email with the number of visits made so far.",
      "prize": "Prize",
      "editPoints": "Edit the visit points of",
      "editPointsInvalid": "The number of points must be less than or equal to"
    },
    "rgpdPage": {
      "title": "Digital GDPR",
      "desc": "Organize your customer data through a digital system compliant with data protection law.",
      "desc2": "This feature is not yet available and will have an extra cost of $4.99/month added to your Pro plan subscription.",
      "cta": "Configure",
      "price": "$4.99/month",
      "inactive": "Inactive",
      "success": "You're now on the waiting list. We will get in touch when this feature becomes accessible."
    },
    "paymentsPage": {
      "title": "Online Payments",
      "desc": "Ensure your customers' commitment, avoid no-shows by accepting deposits from your customers for bookings via MB WAY, Credit Card, Apple Pay, Google Pay (BUK commission 1.9% + $0.50).",
      "advantage1": "Optional or mandatory payment at the time of booking.",
      "advantage2": "Receive a deposit to guarantee the customer's spot. Choose the percentage you wish to receive.",
      "advantage3": "Payments to your bank account the next day.",
      "advantage4": "No need for a PRO subscription. And the deposit into your bank account is also free.",
      "percentage": "Percentage",
      "fixedValue": "Fixed value",
      "cta": "Set up",
      "price": "Commission 1.9% + $0.50",
      "comission": "Commission",
      "comissionFinalDesc": "for each online payment.",
      "activate": "Activate payments",
      "deactivate": "Deactivate payments",
      "active": "Active",
      "inactive": "Inactive",
      "paymentMethods": "Payment Methods",
      "choosePaymentMethods": "Choose your customers' preferred payment methods",
      "paymentOptions": "Payment Options",
      "mandatoryPaymentTitle": "Mandatory Payment",
      "mandatoryPaymentText": "Mandatory payment at the time of booking",
      "depositPaymentTitle": "Set up a deposit",
      "depositPaymentText": "Set a pre-payment amount per service",
      "successMessage": "Payment settings successfully saved",
      "configPaymentsdWarning": "You must set up a payment method",
      "configStripeWarning": "Your Bank Account configuration is incomplete or pending.",
      "someServicesDoNotHavePrice": "Please note that some services are not available for payment because they do not have a set price.",
      "allServicesDoNotHavePrice": "To activate the extension you must set a price in your services",
      "faqTitle": "Frequently Asked Questions",
      "faqTitle1": "When do I receive my money from MBWAY payments?",
      "faqDesc1": "MBWAY payments will be transferred to your Stripe account within 3 business days of payment. You will then receive in the IBAN provided on Stripe according to the chosen frequency.",
      "faqTitle2": "What do I have to pay?",
      "faqDesc2": "Only a commission of 1.9% + $0.50 will be charged on all payments made on your booking page.",
      "faqTitle3": "How do I receive my money?",
      "faqDesc3": "The amount of your payments, minus the commission, will be transferred to the IBAN you provided in the Stripe registration.",
      "faqTitle4": "Do you have any more questions?",
      "faqDesc4": "Contact us at",
      "faqDesc42": "or through",
      "faqTitle5": "How can I make a refund?",
      "faqDesc5": "BUK does not process refunds automatically. In case of cancellation, you should refund the amount directly to your customer.",
      "faqTitle6": "When do I receive my money?",
      "faqDesc6": "To change the frequency (day, week, month) of deposits, simply make that configuration in Stripe.",
      "modalConfirmDeactivate1": "Attention! By deactivating this feature, you are losing a critical tool for your business.",
      "modalConfirmDeactivate2": "Your customers will not be able to make payments on your booking page.",
      "goBack": "Back",
      "someServiceWithNoPrice": "You have some service(s) without a price. Please fix this.",
      "prePaymentOptions": "Prepayment settings",
      "prePaymentOptionsDesc": "Configure rules for online payments such as mandatory prepayment or a minimum deposit amount.",
      "bankAccount": "Bank Account",
      "bankAccountDesc": "Configure your bank account to receive money from your online payments.",
      "notConfigured": "Not configured",
      "emailInfo": "Email to access",
      "bank": "Bank"
    },
    "extensions": {
      "pageTitle": "Extensions",
      "pageDesc": "Supercharge your business operations with our extensions ⚡️",
      "active": "Active",
      "viewExtensions": "View extensions"
    },
    "teyaTerminal": {
      "title": "Teya Terminal",
      "desc": "Order a Teya payment terminal and automate payments at the counter.",
      "cta": "See more",
      "ctaBoxDesc": "We send the terminal and activate the integration in less than 24 hours."
    },
    "navbar": {
      "statistics": "Stats",
      "reports": "Reports",
      "agenda": "Calendar",
      "invoicing": "Invoicing",
      "clients": "Clients",
      "settings": "Settings",
      "marketing": "Marketing",
      "extensions": "Extensions",
      "help": "Need help",
      "subscription": "Subscription",
      "logout": "Logout",
      "week": "Week",
      "shareLink": "Share",
      "downloadQR": "Download QR Code",
      "linkCopied": "Link Copied",
      "editPage": "Edit page",
      "viewPage": "View page",
      "usingFreePlan": "You are using the <strong>Free Plan</strong>",
      "mobilePro1": "Activate the PRO Plan",
      "mobilePro2": "PRO Plan: Pay for 1 month, use 3.",
      "mobilePro3": "More features and greater customization!",
      "becomePro": "BECOME PRO",
      "pastFreeTrial": "Your free trial has ended. To keep using Buk, you need to activate your subscription.",
      "pastDue": "You subscription has expired because of a failed payment. To keep using BUK, you need to change your payment method.",
      "activateSubscription": "Activate subscription",
      "trialingDaysLeft": "Your free trial will end in <strong>{{trialingDaysLeft}} days</strong>. To keep using Buk after that date, you need to activate your subscription.",
      "ignore": "Ignore",
      "subscriptionCancelled": "Your subscription has been cancelled. To keep using Buk, you need to activate your subscription.",
      "freePlanBanner": "Psst... There's a new Professional Plan for 1 user. 👀",
      "seePlan": "See Plan",
      "shareOn": "Share on",
      "copyCode": "Copy link",
      "shareText": "Get a 50% discount for 6 months on any PRO plan of BUK - Online Booking System - with my code:",
      "timeAgo": "{{value}} ago",
      "bookDemo": "Book a ",
      "bookDemo2": "Demo",
      "addToHomescreenCta": "Add to home screen",
      "addToHomescreenCtaSubtitle": "Create a shortcut on your home screen",
      "sales": "Sales"
    },
    "addToHome": {
      "title": "Add to Home Screen",
      "ios1": "Navigate to your calendar and tap the share button in the address bar.",
      "ios2": "In the sharing options list, below the suggested actions, choose “Add to Home Screen”.",
      "android1": "Navigate to your calendar and tap the 'more options' button.",
      "android2": "In the sharing options list, below the suggested actions, choose “Add to Home Screen”."
    },
    "selectStore": {
      "invite": "Win 1 month free",
      "subscription": "Subscription",
      "logout": "Logout",
      "new": "New",
      "account": "My account",
      "help": "Help",
      "addNewStore": "New Store or Calendar"
    },
    "addStore": {
      "title": "Create",
      "storeNameLabel": "Store Name",
      "storeNamePlaceholder": "Name",
      "storeNameInvalidMessage": "Please, fill in the store name.",
      "addressLabel": "Address",
      "addressPlaceholder": "Address",
      "addressInvalidMessage": "Please, fill in the store address.",
      "ctaCancel": "Cancel",
      "ctaCreate": "Create"
    },
    "confirmDeleteRecurrence": {
      "title": "You are deleting a recurring appointment.",
      "deleteOnlyThis": "Delete this one only",
      "deleteAll": "Delete all"
    },
    "confirmDeleteMultiple": {
      "title": "You are deleting a appointment with multiple services.",
      "deleteOnlyThis": "Delete this service only",
      "deleteAll": "Delete all"
    },
    "confirmRemoveProvider": {
      "title": "Remove",
      "cancelAll": "Delete and cancel bookings",
      "notifyClient": "Notify clients of cancelation",
      "transferTo": "Transfer to",
      "desc1": "This provider still has 1 booking, how do you want to proceed?",
      "desc2": "This provider still has {{bookings}} bookings, how do you want to proceed?"
    },
    "createBookingModal": {
      "newBooking": "New appointment",
      "editBooking": "Edit appointment",
      "Booking": "Appointment",
      "openVideoCall": "Open video call",
      "multiBooking": "This appointment is part of a sequence",
      "pastBookingWarning": "You are booking an appointment in the past.",
      "newClientWarning": "No client selected. A new client record will be created.",
      "bookingOutOfBusinessHours": "Exceeds working hours.",
      "bookingConflictHours": "This staff member already has an appointment at this time.",
      "bookingRoomEquipmentConflictHours": "This room/equipment is occupied at this time.",
      "service": "Service",
      "selectServiceInvalid": "Please, select a service",
      "selectServicePlaceholder": "Select a service",
      "client": "Client",
      "clientPlaceholder": "Client name",
      "clientInvalid": "Please, fill in the client name",
      "clientNameMaxLength": "Client name must be at most 255 characters",
      "phoneLabel": "Phone number (with country code)",
      "emailLabel": "Email",
      "emailPlaceholder": "Client email",
      "emailInvalid": "Please, fill in the client email",
      "vatNumberLabel": "VAT number",
      "vatNumberPlaceholder": "Client VAT number",
      "vatNumberInvalid": "Please, fill in the client VAT number",
      "providerLabel": "Staff member",
      "providerPlaceholder": "Select a staff member",
      "providerInvalid": "Please, select a staff member",
      "notesLabel": "Notes",
      "notesPlaceholder": "Notes",
      "hourPlaceholder": "Time",
      "hours": "Time",
      "hour": "Hour",
      "minutes": "Minutes",
      "hourInvalid": "Please, select a time",
      "durationPlaceholder": "Duration",
      "duration": "Duration",
      "durationInvalid": "Please, select a duration",
      "notifyClient": "Notify client",
      "sendPaymentLink": "Include prepayment link",
      "repeatBooking": "Repeat appointment",
      "frequency": "Frequency",
      "until": "Until",
      "saveBooking": "Save",
      "createBooking": "Book",
      "deleteBooking": "Delete",
      "everyWeek": "Every week",
      "everyNWeek": "Every {{N}} weeks",
      "monthlyOnDay": "Monthly on day {{day}}",
      "monthlyOnNthWeekday": "Monthly on the {{ordinal}} {{weekday}}",
      "monthlyOnNthWeekdayMasculine": "Monthly on the {{ordinal}} {{weekday}}",
      "monthlyOnLastWeekday": "Monthly on the last {{weekday}}",
      "monthlyOnLastWeekdayMasculine": "Monthly on the last {{weekday}}",
      "recurrenceOrdinal": {
        "1": "first",
        "2": "second",
        "3": "third",
        "4": "fourth"
      },
      "recurrenceOrdinalMasculine": {
        "1": "first",
        "2": "second",
        "3": "third",
        "4": "fourth"
      },
      "recurrenceWeekday": {
        "0": "Sunday",
        "1": "Monday",
        "2": "Tuesday",
        "3": "Wednesday",
        "4": "Thursday",
        "5": "Friday",
        "6": "Saturday"
      },
      "date": "Choose date",
      "notifyClientConfirm": "Do you wish to send a notification to your costumer regarding this change?",
      "chooseCountry": "Search country...",
      "addService": "More services",
      "missedBooking": "No-show",
      "notMissedBooking": "Showed up",
      "moreFields": "More fields",
      "lessFields": "Less fields",
      "toBePaid": "Client needs to pay",
      "paidOnline": "Paied online",
      "created": "Created",
      "source": {
        "backOffice": "via Backoffice",
        "googleReserve": "via Google Reserve",
        "bookingPage": "via Online"
      },
      "paymentMethods": {
        "money": "Money",
        "mbway": "MBWay",
        "ccard": "Credit Card",
        "googlepay": "Google Pay",
        "applepay": "Apple Pay",
        "paypal": "Paypal",
        "mbref": "Multibanco",
        "null": "-"
      },
      "pay": "Pay",
      "saleRecord": "Sale record",
      "prePaymentLink": "Pre-payment link",
      "seeRegister": "See record",
      "roomEquipment" : "Room / Equipment",
      "selectRoomEquipmentPlaceholder": "No room / equipment"
    },
    "createInvoiceModal": {
      "invoice": "Invoice",
      "invoiceCta": "Invoice",
      "terminalPay": "Pay",
      "vat": "VAT Number (optional)",
      "paymentMethod": "Payment Method",
      "emailLabel": "Client email (optional)",
      "emailPlaceholder": "Client email",
      "nameLabel": "Client name (optional)",
      "namePlaceholder": "Client name",
      "addService": "Add Service",
      "invalidVat": "The inserted Vat Number is not valid",
      "isentionReason": "VAT isention reason",
      "newSale": "New Sale"
    },
    "SIMPLE_PAYMENT_MODAL": {
      "amountLabel": "Valor a cobrar",
      "amountPlaceholder": "0.00",
      "bookingAmount": "Booking amount",
      "method": "Method",
      "sendToTerminal": "Send to terminal",
      "teyaTerminal": "Teya Terminal",
      "waitingPayment": "Waiting for payment at the terminal",
      "paymentReceived": "Payment received",
      "paymentFailed": "Payment failed",
      "paymentFailedDescription": "The payment could not be completed. You can try again.",
      "paymentTimeout": "Payment timed out",
      "send": "Enviar",
      "invoiceTitle": "Issue invoice",
      "invoiceDescription": "Save time with the Buk invoicing module — issue certified invoices from payments.",
      "learnMore": "Learn more"
    },
    "createHolidayModal": {
      "title": "Block Appointments",
      "startDateLabel": "Start",
      "endDateLabel": "End",
      "providerLabel": "Staff member",
      "providerPlaceholder": "Select a staff member",
      "providerInvalid": "Please, select a staff member",
      "reasonLabel": "Reason",
      "reasonPlaceholder": "Reason",
      "reasonMaxLength": "Reason must be at most 500 characters",
      "recurrentEvent": "Recurring",
      "repeatLabel": "Repeat",
      "until": "Until",
      "ctaSave": "Save",
      "ctaBlock": "Block",
      "ctaDelete": "Delete",
      "everyWeek": "Every week",
      "everyNWeek": "Every {{N}} weeks",
      "invalidEndDate": "End date must be after the start date",
      "allProviders": "All staff members"
    },
    "paymentModal": {
      "title": "Activate Plan",
      "noAccess": "Only the account administrator can manage the subscription. Please contact the administrator to update the payment method.",
      "validUntil": "Valid until",
      "couponCode": "Coupon Code",
      "couponCodePlaceholder": "Fill with a coupon code",
      "couponCodeInvalid": "Invalid coupon code",
      "activate": "Activate",
      "changeCard": "Change card",
      "changePaymentMethod": "Change payment method",
      "creditCardNumberLabel": "Card",
      "sepaName": "Account holder name",
      "invalidSepaName": "Invalid account holder name",
      "sepaLabel": "IBAN",
      "changeSepa": "Change IBAN",
      "mandateAcceptance": "By providing your payment information and confirming this payment, you authorise (A) Untold Ventures, Lda and Stripe, our payment service provider and/or PPRO, its local service provider, to send instructions to your bank to debit your account and (B) your bank to debit your account in accordance with those instructions. As part of your rights, you are entitled to a refund from your bank under the terms and conditions of your agreement with your bank. A refund must be claimed within 8 weeks starting from the date on which your account was debited. Your rights are explained in a statement that you can obtain from your bank. You agree to receive notifications for future debits up to 2 days before they occur.",
      "stripeIncorrectNumber": "Incorrect card number.",
      "stripeInvalidNumber": "Invalid card number.",
      "stripeinvalidExpiryNumber": "Invalid card expiry month.",
      "stripeInvalidExpiryYear": "Invalid card expiry year.",
      "stripeInvalidCVC": "Invalid CVC code.",
      "stripeExpiredCard": "Expired card.",
      "stripeIncorrectCVC": "Incorrect CVC code.",
      "stripeIncorrectZip": "Invalid Zip code.",
      "stripeCardDeclined": "Declined Card.",
      "stripeMissing": "Client does not have credit card.",
      "stripeProcessingError": "There was a problem processing the payment.",
      "successPayment": "🎉 Payment received 🎉 Your plan is now active. Happy scheduling!",
      "successPaymentTitle": "Payment received 🎉",
      "successPaymentMsg": "Did you know you can invite friends and earn €100?",
      "successPaymentMsg2": "Save on your subscription and give a discount to a friend who has a business.",
      "successPaymentInviteFriends": "Invite Friends",
      "vatNumber": "VAT Number (optional)",
      "vatNumberPlaceholder": "VAT Number",
      "vatNumberInvalid": "Invalid VAT Number (ex: {{value}}999999999)",
      "successUpdatePaymentMethod": "Payment method updated",
      "successDiscountCode": "Coupon Code Applied Successfully",
      "backToCalendar": "Back to Calendar",
      "mbwayNotification1": "You will receive a notification to make a",
      "mbwayNotification2": "payment of",
      "sepaNotAllowed": "This payment method is not available due to the high number of failed collection attempts. Please use another payment method.",
      "phoneMbway": "Phone used on MBWay",
      "pay": "Pay",
      "backToPlans": "Back to plans",
      "plan": "{{value}} plan",
      "youAreSaving": "You're saving",
      "paymentMethod": "Payment method",
      "paymentPeriod": "Subscription period",
      "vat": "VAT",
      "totalMonthly": "Monthly Total",
      "totalYearly": "Yearly Total",
      "subscription": "Subscription",
      "payNow": "Pay now",
      "cancel": "Cancel",
      "waitingMBWayPayment": "Waiting for MBWay payment...",
      "authorizeMBWayPayment": "Authorize payment on your mobile phone",
      "waitingPayment": "Waiting payment...",
      "mbrefEntity": "Entity:",
      "mbrefReference": "Reference:",
      "mbrefAmount": "Amount:",
      "referralText": "Referral discount applied!",
      "referralText2": "50% off for 6 months",
      "referralDiscount": "Discount (Referral)",
      "errorCoupon": "The discount code entered is not valid.",
      "discountCodeLabel": "Discount (Code)",
      "discountApplied": "Discount applied!",
      "for": "for",
      "months": "month(s)"
    },
    "paymentFlashCampaignModal": {
      "header": "72H LIMITED PROMO",
      "title1": "Pro Plan 3 months",
      "title2": "for the price of 1!",
      "pay": "Pay",
      "offerEndsIn": "Offer expires in",
      "onlyAvailable": "MBWay only deal",
      "nextPayment": "Next payment:",
      "payNow": "Pay now",
      "aboutPROPlan": "About the Pro Plan"
    },
    "discountCodePage": {
      "howManyProviders": "How many staff members?"
    },
    "plansModal": {
      "title": "Subscription",
      "planUsing": "You are using the ",
      "planName": "{{nickname}} Plan",
      "free": "Free",
      "professional": "Pro",
      "professionalPlus": "Pro+",
      "planBookingPage": "Booking Page",
      "planOnlineAgenda": "Online Calendar",
      "planEmailReminders": "Unlimited Email Reminders",
      "planEmailReminders100": "Email reminders (100 free/month)",
      "plan1Provider": "1 Staff member",
      "planStats": "Statistics",
      "syncGoogleCalendar": "Google Calendar Sync",
      "planSMSReminders": "Text reminders",
      "activePlan": "ACTIVE PLAN",
      "cancelSubscription": "CANCEL SUBSCRIPTION",
      "haveMoreThanPossibleProviders": "You have {{numberOfProviders}} active staff members, this plan only allows for one staff member.",
      "activatePlan": "CONTINUE",
      "useBukWithoutLimits": "Enjoy BUK without constraints with our Professional Plan.",
      "until": "Up to",
      "provider": "Staff member",
      "providers": "Staff members",
      "haveMoreThanNPossibleProviders": "You have {{numberOfProviders}} active staff members and the selected plan only allows for {{providersAmount}}, <b>to continue you need to remove staff members.</b>",
      "chooseProvidersToRemove": "Choose staff members to remove",
      "forMoreThan": "For more than",
      "or": "or",
      "contactUs": "contact us",
      "downgradeToFree": "Are you sure you want to downgrade? You will lose the features available on the Professional Plan.",
      "downgradeFromProPlus": "Are you sure you want to continue? You will lose the exclusive features of the Pro+ Plan:",
      "with-sms": "With Text reminders",
      "without-sms": "Without Text reminders",
      "annual-plan": "Paid yearly",
      "paid-annual-plan": "Paid yearly (-20%)",
      "paid-monthly-plan": "Paid monthly",
      "credit-card": "Credit Card",
      "direct-debit": "Direct Debit"
    },
    "upgradePlanModal": {
      "title": "Upgrade your plan",
      "toAdd": "To add ",
      "moreProviders": "more staff members",
      "needToUpdatePlan": "you need to update your current plan.",
      "toSync": "To sync with",
      "toUse": "To use",
      "toSee": "To see",
      "seePlans": "See other plans",
      "ctaUpdatePlan": "Upgrade now",
      "recurringAppointment": "recurring appointments",
      "stats": "statistics",
      "posSettings": "invoice integration",
      "multiBooking": "multi-service scheduling",
      "sms": "Text reminders",
      "customBookingPage": "Custom booking page",
      "footerNote": "custom footer",
      "calendarSettings": "calendar settings",
      "customEmail": "custom e-mails",
      "serviceCategory": "service separators",
      "serviceImage": "service images",
      "googleReserve": "Google Reserve",
      "googleReviews": "Google Reviews",
      "websiteEmbed": "Website Embed Code",
      "needToUpdatePlanToPlus": "you need to update your current plan to the Pro+ Plan."
    },
    "chooseBookOrBlockModal": {
      "newAppointment": "New appointment",
      "blockTime": "Block time",
      "teyaSoloPay": "Terminal payment"
    },
    "chooseProvidersToRemoveModal": {
      "title": "Choose staff members to remove",
      "subtitle": "Select the staff members you want to remove to continue with your plan selection",
      "loadingProviders": "Loading staff members...",
      "warningMessage": "<b>Attention! When removing staff members:</b><br/>- Your appointments will disappear<br/>- Users will lose access",
      "goBack": "Go back",
      "removeNow": "Remove now",
      "successTitle": "Staff members removed successfully",
      "successMessage": "The selected staff members were successfully removed. Now you can update your subscription.",
      "viewPlans": "View plans",
      "errorLoadingProviders": "Error loading staff members. Please try again.",
      "errorRemovingProviders": "Error removing staff members. Please try again."
    },
    "userRoles": {
      "admin": "Admin",
      "admin_note": "[general access to all Stores, Menus and Settings]",
      "manager": "Manager",
      "manager_note": "[access only to this Store, without access to Stats Menu]",
      "store": "Store PC",
      "provider": "Staff member",
      "provider_note": "[limited access to one calendar]"
    }
  },
  "ONBOARD": {
    "setupStoreSuccess": {
      "doneTitle": "That's it! 🎉",
      "guidanceTitle": "Nice. Now just have to share your booking page link with your clients!",
      "viewPage": "See page",
      "copyLink": "Copy link",
      "linkCopied": "Link Copied"
    },
    "step1Title": "Welcome to your calendar! 🎉",
    "step1Text": "Manage your appointments easily. Access your digital calendar anytime, anywhere on your computer or smartphone.",
    "step2Title": "Customize your Booking Page",
    "step2Text": "Click the link on the main menu bar and edit your booking page.",
    "step3Title": "Share your link with your clients!",
    "step4Title": "Book a demonstration",
    "step4Text": "If you have any questions about your online calendar, contact us or book a free demonstration.",
    "step4Help1": "Need help?",
    "step4Help2": "Email us at support@buk.app",
    "btnContinue": "Continue",
    "btnExplore": "Start exploring",
    "bookADemoBtn": "Book free demo",
    "watchDemoBtn": "Watch demo"
  },
  "DASHBOARD": {
    "activate": "Activate",
    "deactivate": "Deactivate",
    "updateAvailable": "Update required, click here.",
    "teyaSetupPage": {
      "companyData": "Company details",
      "companyDataDesc": "We use this information to prepare the contract and delivery of the Teya terminal.",
      "contractData": "Contract details",
      "contractDataDesc": "Company identification and estimated card volume.",
      "deliveryAddress": "Delivery address for the terminal and cards",
      "deliveryAddressDesc": "Where we send the terminal and, if you join the Teya Business Account, the cards.",
      "companyName": "Company name",
      "companyNamePlaceholder": "Enter company name",
      "vatNumber": "VAT number",
      "vatNumberPlaceholder": "Enter VAT number",
      "phoneNumber": "Phone number",
      "phoneNumberPlaceholder": "Enter phone number",
      "email": "Email",
      "emailPlaceholder": "Enter email address",
      "invoicingDesc": "Card payments only - not the total salon revenue. Suggested based on Buk sales (less a cash portion); adjust if your reality is different.",
      "monthlyCardVolume": "Monthly card revenue",
      "monthlyCardVolumePlaceholder": "Select monthly card revenue",
      "contractType": "Choose the plan",
      "contractTypeDesc": "Select a pricing plan and where you want to receive payments.",
      "cashback": "cashback",
      "noMonthlyFee": "No monthly fee",
      "perMonth": "/month",
      "settlementIn": "Settlement in",
      "teyaBusinessAccount": "Teya Business Account",
      "teyaBusinessAccountInfoTitle": "What is the Teya Business Account?",
      "teyaBusinessAccountInfoDesc": "When you receive payments in a Teya Business Account, you get a debit card with 0.5% cashback on purchases — which helps offset the monthly fee you choose.",
      "ownBankAccount": "Your bank account",
      "fewTransactionsDescription": "Best for businesses with few transactions: avoid the monthly fee by paying a small fixed fee per transaction.",
      "manyTransactionsDescription": "Best for businesses with many small transactions: the monthly fee is spread across transactions and cashback helps offset it.",
      "ownBankDescription": "For those who prefer to keep their money in their usual bank account, without Teya Business cashback.",
      "personalCredit": "Personal credit",
      "businessOrInternational": "Business or international",
      "personalDebit": "Personal debit",
      "amexAndOtherCards": "AMEX and other cards",
      "yourPlan": "Your plan:",
      "plans": {"simple": "Teya Simple","advanced": "Teya Advanced","premium": "Teya Premium","private": "Teya Private"},
      "perTransaction": "/txn",
      "terminalFee": "Terminal",
      "terminalCharged": "Charged",
      "terminalOffered": "Free",
      "terminalHalfPrice": "50% off",
      "terminalHalfPriceNote": "* 50% discount on the terminal; full offer subject to approval.",
      "selected": "Selected",
      "choose": "Choose",
      "address": "Address",
      "addressPlaceholder": "Enter address",
      "postalCode": "Postal code",
      "postalCodePlaceholder": "Enter postal code",
      "city": "City",
      "cityPlaceholder": "Enter city",
      "terminalType": "Choose your terminal",
      "terminalTypeDesc": "All terminals accept cards, contactless and arrive configured for BUK.",
      "vatIncluded": "+ VAT",
      "printer": "Printer",
      "chooseTerminal": "Choose terminal",
      "terminalDescriptions": {
        "teya_pro": "Elegant design, long-lasting battery and integrated printer.",
        "teya_go": "Lightweight, reliable and ideal for businesses on the move.",
        "teya_lite": "Our most compact terminal, made for small counters and businesses always on the move."
      },
      "li1": "Integrated with BUK's sales system.",
      "li2": "Zero checkout errors: eliminate discrepancies between BUK and terminal reports.",
      "li3": "Fast payments: reduce checkout service time when closing the appointment.",
      "ctaBoxTitle": "Don't have a Teya payment terminal yet?",
      "oauthTitle": "Log in to Teya",
      "oauthDesc": "After logging in, BUK selects the terminal linked to your account — in most cases there is only one.",
      "oauthCta": "Log in to Teya",
      "oauthConnectedTitle": "Teya account",
      "oauthConnectedDesc": "Successfully logged in",
      "cloudModeInstructions":  "To stay connected to BUK, the terminal must be in <b>cloud mode</b>. On the terminal: Menu → POS integrations (at the bottom of the menu) → Cloud communication → Exit the menu.",
      "disconnectCta": "Log out",
      "terminalsTitle": "Terminal",
      "terminalsDesc": "Choose the terminal from this Teya account to use for BUK sales.",
      "terminalLabel": "Associated terminal",
      "saveTerminalsBtn": "Save",
      "activateTeya": "Join Teya",
      "sendRequest": "Send Request",
      "requestSent": "Request sent!",
      "requestSentDescription": "We have received your request to join Teya. Our team will review it and send a proposal shortly.",
      "responseTime": "Typical response time: up to 48 hours.",
      "conclude": "Finish",
      "awaitingProposal": "Awaiting a proposal",
      "awaitingProposalDesc": "We have received your request to join. Our team will contact you shortly.",
      "monthlyCardVolumeOptions": {
        "under_2500": "Under €2,500",
        "2500_5000": "Between €2,500 and €5,000",
        "5000_10000": "Between €5,000 and €10,000",
        "10000_15000": "Between €10,000 and €15,000",
        "15000_30000": "Between €15,000 and €30,000",
        "30000_50000": "Between €30,000 and €50,000",
        "over_50000": "Over €50,000"
      },
      "settlementAccountOptions": {
        "teya_business": "Teya business account",
        "own_bank": "Own bank account"
      },
      "terminalOptions": {
        "teya_pro": "Teya Pro",
        "teya_go": "Teya Go",
        "teya_lite": "Teya Lite"
      }
    },
    "referralPage": {
      "title": "Invite your friends <br/>& Get 100€",
      "subtitle": "Offer a 50% discount to your friends and get €50 in Marketing credits + €50 in subscription credit.",
      "cta": "Invite friends",
      "ctaSubtitle": "Win €100 / referral",
      "viewReferrals": "My referrals",
      "viewRewards": "My rewards",
      "box1": "Spread the word by sharing your referral link or via social sharing",
      "box2": "Your friend subscribes to any BUK PRO plan with a 50% discount for 6 months",
      "box3": "You get 50€ in Marketing credits + 50€ credit on your subscription",
      "title2": "Keep inviting & Keep earning",
      "subtitle2": "You win, your friends win! There's no limit of invitations.",
      "faqQ1": "How can I join the program?",
      "faqA1": "You don't need to join. Click on 'Invite Friends' and share your invitation link.",
      "faqQ2": "How do get rewarded?",
      "faqA2": "The day your friend pays any Pro plan, you get 50€ in Marketing credits + 50€ credit on your subscription.",
      "faqQ3": "How many friends can I invite?",
      "faqA3": "There's no limit to invitations. The more you invite, the higher your chances of winning!",
      "faqQ4": "How do I know if my friends paid?",
      "faqA4": "Use the section below to track how many of your friends registered their business and your rewards.",
      "yourReferrals": "Your Referrals",
      "yourRewards": "Your Rewards",
      "registered": "Registered",
      "added": "Added",
      "inMarketing": "in Marketing",
      "inSubscriptionCredit": "in Subscription Credit",
      "emptyReferrals": "You don't have any referrals yet",
      "emptyRewards": "You don't have any rewards yet"
    },
    "multipleServiceSettings": {
      "title": "Multiple service booking",
      "description": "With this option your clients can select more then one service in the same appointment.",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "config": "Set rules",
      "configDesc": "Set one or more rules for bookings with multiple services"
    },
    "posSettings": {
      "title": "Moloni integration",
      "discontinued": "Discontinued",
      "description": "Issue your invoices directly from BUK with your Moloni Flex or Pro account. Includes 2 months free on Moloni exclusive for BUK customers.",
      "link": "Learn more",
      "deactivate": "Deactivate",
      "activate": "Activate"
    },
    "salesSettings": {
      "title": "Sales Record",
      "description": "Track the money coming in and out daily with the sales record.",
      "cta": "Configure"
    },
    "invoicingSettings": {
      "title": "BUK Invoicing",
      "description": "Issue invoices and manage your accounting directly in BUK with our invoicing module.",
      "cta": "Configure"
    },
    "salesSetupPage": {
      "title": "Sales Record",
      "active": "Active",
      "inactive": "Inactive",
      "desc": "Track the money coming in and out daily with the sales record module.",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "help": "Help",
      "boxTitle": "What's included?",
      "li1": "Sales management menu",
      "li2": "Record of payments and discounts",
      "li3": "Record of customer debts",
      "li4": "Record of commissions",
      "cancelTitle": "Caution!",
      "cancelDescription": "By deactivating the sales module, you will lose access to features that may be critical to your business, such as Payment Management, Sales Statistics, and Commissions.",
      "continue": "Continue",
      "tutorialTitle0": "Sales Module Activated!",
      "tutorialDescription0": "You can now manage your sales within BUK, click continue to learn more.",
      "tutorialTitle1": "Sales Management Menu",
      "tutorialDescription1": "Access the new Sales menu through the main navigation, here you can see all sales records, payments, and commissions.",
      "tutorialTitle2": "Sales Record",
      "tutorialDescription2": "Record your sales in seconds, with a simple and intuitive process. Add discounts and choose one or more payment methods.",
      "tutorialTitle3": "Commissions",
      "tutorialDescription3": "Configure your collaborators' commissions and view reports in the Sales menu.",
      "tutorialTitle4": "BUK Invoicing Module",
      "tutorialDescription4": "You can now also issue invoices directly in BUK with our integrated invoicing module.",
      "managePermissions": "Permissions",
      "permissionsModal": {
        "title": "Sales permissions",
        "subtitle": "Choose who can view, edit, or delete sales data for this store.",
        "columnUser": "User",
        "columnView": "View",
        "columnEdit": "Edit",
        "columnDelete": "Delete",
        "adminFootnote": "Administrators always have full access to sales; checkboxes for those accounts are shown for reference only.",
        "save": "Save",
        "cancel": "Cancel",
        "close": "Close",
        "loading": "Loading users…",
        "loadError": "Could not load the user list."
      },
      "invoiceActiveTitle": "You need the sales module active to use the invoicing module",
      "invoiceActiveDescription": "To deactivate the sales module, you must first deactivate the invoicing module.",
      "goToInvoicing": "Learn more about invoicing"
    },
    "invoicingOnboardSetupPage": {
      "emailAddress": "Email",
      "postalCodeInvalid": "Postal code must be in format XXXX-XXX"
    },
    "storeSettingsPage": {
      "businessName": "Name",
      "invalidBusinessName": "Please, fill in your store name.",
      "phone": "Phone number (with country code)",
      "phonePlaceholder": "Phone number",
      "invalidPhone": "Please, fill in your phone number",
      "addressPlaceholder": "Fill in your address",
      "address": "Address",
      "invalidAddress": "Please, fill in your address",
      "allowBookingsOnlyBefore": "Do not allow customers to book within:",
      "maxDaysInAdvance": "Do not allow customers to book beyond:",
      "allowBookingsOnlyBeforeEx": "Ex. A client won't be able to book a service for 30 minutes from now (if you have 1 hour configured)",
      "maxDaysInAdvanceEx": "Ex. A client won't be able to book a service for 13 months from now (if you have 12 months configured)",
      "calendarIntervals": "Custom time slot:",
      "notificationAdvanceTime": "Time before appointment to send E-mail and Text reminders",
      "notificationAdvanceTimeNoSMS": "Time before appointment to send E-mail reminder",
      "timezone": "Timezone:",
      "slug": "URL",
      "invalidSlug": "Invalid Url",
      "deleteStoreSure": "Are you sure you want to delete you store \"{{insert}}\"? Attention: is action can not be reverted.",
      "pageTitle": "General settings",
      "basicStoreTitle": "Basic information",
      "basicStoreDesc": "Keep your basic information<br/> up to date",
      "configStoreTitle": "Calendar & booking page",
      "configStoreDesc": "Adapt and configure your calendar to your business needs",
      "notesOnEvents": "Show notes on calendar",
      "notesOnEventsNo": "No",
      "notesOnEventsYes": "Yes",
      "hideProvidersOutOfOffice": "Hide providers not working from calendar",
      "hideProvidersOutOfOfficeNo": "No",
      "hideProvidersOutOfOfficeYes": "Yes",
      "customFieldsTitle": "Custom Fields",
      "customFieldsDescription": "Add custom fields to your booking page and gather additional information from your clients",
      "customFieldsConfig": "Configure",
      "customFieldsEmptyState": "There are no custom fields.",
      "optimizeOnlineBookings": "Optimize online bookings",
      "optimizeOnlineBookingsDescription": "Reduce gaps in your schedule and improve occupancy by setting the times clients can book online",
      "minimizeHolesOnCalendarNo": "Regular time slots",
      "minimizeHolesOnCalendarNoDescription": "Show all available time slots based on the defined interval. This may create gaps in your schedule",
      "minimizeHolesOnCalendarYes": "Reduce gaps in the calendar",
      "minimizeHolesOnCalendarYesDescription": "Intelligently display more available time slots to your clients, avoiding difficult-to-fill gaps in the schedule"
    },
    "storeMessagingPage": {
      "pageDisclaimer": "Here you can see the automated messages that we send to your clientes whever you create an appointment, edit, cancel.",
      "guidanceTitleConfirm": "Appointment Booked",
      "confirmEmail": "Hi <strong>%NAME%</strong>, <br/>Your <strong>%BUSINESS_NAME%</strong> appointment has been booked.<br/>Service: <strong>%SERVICE%</strong><br/>Date: <strong>%DATE%</strong><br/><br/>{{insert}} Resource: <strong>%RESOURCE%</strong><br/><br/>If you want to cancel this appointment, simply click on the following link <strong>%CANCELLATION_LINK%</strong> or call us at <strong>%PHONE%</strong><br/><br/>Thank you",
      "guidanceTitleEdited": "Your appointment has been changed",
      "editedEmail": "Hi <strong>%NAME%</strong>,<br/>Your appointment (<strong>%BUSINESS_NAME%</strong>) has been changed to <strong>%DATE%</strong>.<br/><br/>{{insert}} If you want to cancel this appointment, simply click on the following link <strong>%CANCELLATION_LINK%</strong> or call us at <strong>%PHONE%</strong><br/><br/>Thank you",
      "guidanceTitleCanceled": "Appointment has been canceled",
      "canceledEmail": "Hi <strong>%NAME%</strong>, <br/>Your appointment for <strong>%BUSINESS_NAME%</strong> on <strong>%DATE%</strong> has been canceled.<br/><br/>{{insert}} Contact us at <strong>%PHONE%</strong> for more information.<br/><br/>Thank you",
      "guidanceTitleReminder": "Appointment Reminder",
      "reminderEmail": "Hi <strong>%NAME%</strong>,<br/> This is just a reminder that you have an appointment on <strong>%DATE%</strong> with <strong>%BUSINESS_NAME%</strong><br/><br/>{{insert}} If you want to cancel this appointment, simply click on the following link <strong>%CANCELLATION_LINK%</strong> or call us at <strong>%PHONE%</strong><br/><br/>Thank you",
      "emailTitle": "Email",
      "smsTitle": "Text messages",
      "smsGuidance": "You have to be on a paid plan in order for your clients to receive text messages",
      "editedSMS": "Your appointment has been changed to %DATE% %BUSINESS_NAME%. If you wish to cancel follow this link %CANCELLATION_LINK% or call %PHONE%",
      "canceledSMS": "Your appointment for %DATE% %BUSINESS_NAME% has been canceled. Contact us at %PHONE% for more information.",
      "reminderSMS": "This is just a reminder that you have an appointment on %DATE% (%BUSINESS_NAME% - %PHONE%)",
      "importantInformation": "Important information:",
      "importantInformationHelper": "Optionally you can add extra information in the email:",
      "guidanceSenderSMS": "From ",
      "invalidChangeBookingSMS": "Mandatory field: enter a message for Changed Appointment (max: 160 characters)",
      "invalidCanceledBookingSMS": "Mandatory field: enter a message for Canceled Appointment (max: 160 characters)",
      "invalidReminderSMS": "Mandatory field: enter a message for Appointment Reminder (max: 160 characters)",
      "resetText": "Reset to original text",
      "invalidSenderSMS": "Mandatory field: enter the Sender Name (max: 11 characters)",
      "senderStatusApproved": "Approved",
      "senderStatusPending": "Pending approval",
      "senderStatusRejected": "Rejected",
      "senderStatusFallbackNote": "While this sender is not approved, SMS messages are sent from the \"BUK\" sender name.",
      "senderStatusRejectedNote": "This sender name was rejected. Try a different name. In the meantime, SMS messages will be sent from the \"BUK\" sender name.",
      "customSmsTitle1": "Customize your text reminders",
      "customSmsTitle2": "Use the special fields below to customize your message",
      "fieldsDate": "for date of appointment in relative format (ex: Thursday, 1 January 09:30)",
      "fieldsDateFull": "for date of appointment in full format (ex: 01/01/2026 09:30)",
      "fieldsStoreName": "for store name",
      "fieldsStoreContact": "for store contact",
      "fieldsProviderName": "for the staff member name",
      "fieldsServiceName": "for the service name",
      "fieldsCancelLink": "for appointment cancellation link",
      "fieldClientName": "for client name",
      "dateField": "%DATE%",
      "dateFullField": "%DATE_NUM%",
      "storeNameField": "%BUSINESS_NAME%",
      "clientNameField": "%CLIENT_NAME%",
      "providerNameField": "%STAFF_MEMBER%",
      "serviceNameField": "%SERVICE%",
      "phoneField": "%PHONE%",
      "cancelLinkField": "%CANCELLATION_LINK%",
      "birthdaySMS": "Birthday Text reminder",
      "birthdaySmsSetting": "Send Text reminder on Customers' Birthdays",
      "birthdayMessage": "On this special day we wish a great birthday on behalf of the whole team at %BUSINESS_NAME%",
      "invalidClientBirthdayMessage": "Mandatory field: enter a message for Birthday Text reminder (max: 160 characters)",
      "senderStatusUnsaved": "To submit your sender, click \"Save\" at the bottom of the page.",
      "nameInstructions": "Read our tips for choosing a sender name",
      "namingInstructionsTitle": "SMS Sender",
      "namingInstructionsDescription": "In some cases, telecommunications operators, such as MEO, Vodafone, NOS, among others, as well as the mobile devices themselves, may automatically classify some messages as spam.<br/><br/>Unfortunately, this filtering is done by the operators or the systems of the devices themselves, so we have no direct control over this decision.<br/><br/>We have observed that, both in Portugal and in other countries, operators have been making SMS filters more stringent, aiming to reduce the increase in spam and fraudulent messages.<br/><br/>When the SMS sender is a personal or too generic name, instead of the business name, there is a higher probability that the message will be filtered or flagged as spam.<br/><br/>If you are having problems with SMS delivery, we recommend changing the sender name to something more identifiable and associated with the business. Alternatively, you can also try using \"BUK\" as the sender."
    },
    "calendarPage": {
      "today": "TODAY",
      "block": "Block Time",
      "book": "New Appointment",
      "newInvoice": "New Invoice",
      "teyaSoloPay": "Terminal payment",
      "week": "Week",
      "threeDay": "Three days",
      "blocked": "BLOCKED",
      "day": "Day",
      "providerSelected": "Preference for this staff member",
      "invoiceExists": "Invoice exists",
      "paid": "Pre-Paid online",
      "noCalendars": "Day without active schedules",
      "isLoyaltyPrizeBooking": "Loyalty Prize",
      "defaultName": "Example",
      "add": "Create",
      "providers": "Team",
      "roomEquipment": "Room / Equipment",
      "roomEquipmentShort": "Room/Equip.",
      "roomOccupied": "OCCUPIED"
    },
    "storeSettingsMenu": {
      "services": "Services",
      "products": "Products",
      "providers": "Team",
      "workplan": "Schedule",
      "notifications": "Notifications",
      "users": "Users",
      "rooms": "Rooms"
    },
    "workplanOverride": {
      "title": "Special schedules",
      "description": "Configure schedules for special days.",
      "upcomingExceptions": "Upcoming schedules",
      "newException": "New schedule",
      "noExceptions": "You don't have any special schedules configured yet.",
      "collaboratorsText": "provider(s)",
      "chooseDay": "Choose a day",
      "invalidDate": "Please select a valid date",
      "dateRequired": "Please select a date",
      "timeSlots": "Time slots",
      "chooseProviders": "Choose the providers",
      "atLeastOneProviderRequired": "Please select at least one provider"
    },
    "clientSettingsMenu": {
      "clients": "Clients",
      "blacklist": "Blacklist"
    },
    "selectProvider": {
      "generalView": "General View",
      "newResource": "New Staff member"
    },
    "newClientForm": {
      "addClient": "Add Client",
      "name": "Name",
      "namePlaceholder": "First and last name",
      "invalidName": "Please, fill in the client name",
      "email": "Email",
      "emailPlaceholder": "Email",
      "invalidEmail": "Please, fill in the client email",
      "vatNumber": "VAT Number",
      "vatNumberPlaceholder": "VAT Number",
      "invalidvatNumber": "Please, fill in the client VAT number",
      "phone": "Mobile phone number (with country code)",
      "invalidNumber": "Invalid mobile phone number",
      "notifyClient": "Send email with your Booking Page link",
      "notes": "Notes",
      "notesPlaceholder": "Notes",
      "notifications": "E-mail/Text campaigns",
      "subscribed": "Subscribed",
      "unsubscribed": "Unsubscribed"
    },
    "newClientBlacklistForm": {
      "addClient": "Block Cliente",
      "name": "Name",
      "namePlaceholder": "First and last name",
      "invalidName": "Please, fill in the client name",
      "email": "Email",
      "emailPlaceholder": "Email",
      "invalidEmail": "Please, fill in the client email",
      "phone": "Mobile phone number (with country code)",
      "invalidNumber": "Invalid mobile phone number"
    },
    "clientsPage": {
      "search": "Searching...",
      "create": "Add",
      "newClient": "Add new client",
      "emptyStateH3": "You still don't have clients",
      "emptyStateP": "Add new clients or share your Booking Page to get your first clients!",
      "emptyStateH3Blacklist": "You still don't have blocked clients",
      "contactImportTitle": "Import your clients list",
      "contactImport": "To import all your contacts, contact us to: ",
      "tableHeaders": {
        "name": "Name",
        "email": "Email",
        "phoneNumber": "Phone number",
        "bookings": "Bookings",
        "lastVisit": "Last visit"
      },
      "filters": {
        "name": "Name Az",
        "bookingsAsc": "More bookings",
        "bookingsDesc": "Less bookings",
        "lastVisitAsc": "Recent visits",
        "lastVisitDesc": "Older visits"
      },
      "newCampaign": "Send campaign",
      "inactiveClientsTitle": "Call your inactive customers back!",
      "inactiveClientsDesc": "Offer a discount and promote your services with an Text campaign.",
      "activeClientsTitle": "Communicate with your customers",
      "activeClientsDesc": "Send an Text campaign using our Marketing system.",
      "noContacts": "No contacts added",
      "importingDescription": "We are importing your customers, this process can take up to 24 hours",
      "importButton": "Import",
      "exportButton": "Export",
      "importExportButton": "Import / Export"
    },
    "importClients": {
      "title": "Import customers",
      "subtitle": "Upload your customer list",
      "importButton": "Import",
      "uploadFile": "File Upload",
      "uploadFileDescription": "Formats: .xls, .csv or .vcf",
      "importExportTitle": "Import / Export Customers",
      "importExportSubtitle": "Import new customers or export your existing customer list",
      "importMode": "Import",
      "exportMode": "Export",
      "exportTitle": "Export Customers",
      "exportDescription": "Export {{count}} customers to Excel",
      "exportButton": "Export",
      "exportNoClients": "You don't have any clients to export",
      "csvExport": {
        "name": "Name",
        "email": "Email",
        "phoneNumber": "Phone Number",
        "notes": "Notes",
        "subscribed": "Accepts marketing communications?",
        "vatNumber": "VAT Number",
        "bookings": "Number of Bookings",
        "lastVisit": "Last Visit"
      }
    },
    "clientForm": {
      "personalInfo": "Personal Information",
      "general": "General",
      "name": "Name",
      "namePlaceholder": "First and last name",
      "email": "Email",
      "emailPlaceholder": "Email",
      "emailInvalid": "Please, fill in the client email",
      "vatNumber": "VAT Number",
      "vatNumberPlaceholder": "VAT Number",
      "vatNumberInvalid": "Please, fill in the client VAT number",
      "phone": "Mobile phone number (with country code)",
      "phoneInvalid": "Invalid mobile phone number",
      "deleteClient": "Delete Client",
      "bookings": "Appointments",
      "emptyBookings": "The client hasn't booked any appointment yet...",
      "addToBlacklist": "Block",
      "removeFromBlacklist": "Unblock",
      "notes": "Notes",
      "notesPlaceholder": "Notes",
      "subscribed": "The client wishes to receive e-mail and Text campaings",
      "dob": "Birthday",
      "stats": "Stats",
      "history": "History",
      "seeMore": "See more ▾",
      "loadMore": "Load more",
      "nextBookings": "Next appointments",
      "complete": "Complete",
      "canceled": "Canceled",
      "noshow": "NoShow",
      "totalValue": "Total value",
      "lastVisitHeader": "Last booking",
      "activeClient": "Active client",
      "inactiveClient": "Inactive client",
      "newClient": "New client",
      "options": "Options",
      "editClient": "Edit",
      "canceledBy": "Canceled by",
      "createdBy": "Created by",
      "client": "client",
      "canceledByCustomer": "Canceled by customer",
      "source": "Source",
      "gender": "Gender",
      "customFields": "Custom Fields",
      "whatsapp": "Send WhatsApp",
      "sales": "Sales",
      "files": "Files"
    },
    "clientAttachments": {
      "upload": "Choose files",
      "drag": "File Upload",
      "fileTypeSize": "PDF, JPG, PNG, DOCX, etc (Max. {{max}}MB)",
      "noAttachments": "No attachments.",
      "document": "Document",
      "fileTooLarge": "File too large. Maximum size is {{max}}MB."
    },
    "documentPreviewModal": {
      "cannotPreview": "Cannot preview this file type",
      "downloadToView": "Download to view",
      "download": "Download",
      "downloadAttachment": "Download",
      "deleteAttachment": "Delete",
      "deleteAttachmentTitle": "Are you sure you want to delete this attachment?"
    },
    "statsPage": {},
    "userForm": {
      "createUser": "Create user",
      "editUser": "Edit user",
      "name": "Name",
      "namePlaceholder": "Name",
      "invalidName": "Invalid Name",
      "email": "Email",
      "emailPlaceholder": "Email",
      "invalidEmail": "Invalid Email",
      "roleLabel": "Role",
      "rolePlaceholder": "Role",
      "roleInvalidMessage": "Invalid Role",
      "createUserButton": "Create user",
      "editUserButton": "Save",
      "deleteUser": "Delete",
      "resendInvitation": "Resend Invitation Email",
      "inviteLinkLabel": "Link to set password",
      "inviteLinkLoading": "Loading link...",
      "instructions": "An invitation will be sent to this email address.",
      "salesPermissions": "Sales Permissions",
      "canCreateEditSales": "Can create and edit sales",
      "canViewSales": "Can view sales",
      "canDeleteSales": "Can delete sales"
    },
    "setupStoreUsers": {
      "guidanceTitle": "Manage your user roles",
      "activeUser": "Active",
      "inactiveUser": "Inactive",
      "addNew": "Add new"
    },
    "stripeSettings": {
      "title": "Online Payments (Stripe)",
      "description": "Credit card, Apple Pay, Google Pay (6% commission).",
      "configure": "Configure",
      "mandatoryPayments": "Activate Mandatory payments",
      "optionalPayments": "Deactivate Mandatory payments",
      "mandatoryPaymentsAreDeactived": "The payment is not required to schedule an appintment.",
      "mandatoryPaymentsAreActived": "The payment is required to schedule an appintment."
    },
    "paymentSettings": {
      "title": "Online Payments for your bookings",
      "description": "Credit card, Apple Pay, Google Pay (6% commission).",
      "configure": "Configure"
    },
    "accountSettingsMenu": {
      "account": "My account",
      "subscription": "Subscription",
      "invoices": "Invoices",
      "invoicesText": "Your invoices will be available at the beginning of the next day"
    },
    "tutorialBanner": {
      "tip1": "How to make a booking",
      "tip2": "Menus and calendar features",
      "tip3": "How to customize your booking page",
      "watchPlaylist": "View playlist"
    },
    "embedCodeSetup": {
      "wordpress1": "If your website is developed on Wordpress",
      "wordpress2": "click here to see our plugin",
      "copyCode": "Copy embed code",
      "copyCodeSuccess": "Code copied to clipboard"
    },
    "setupCustomFields": {
      "text": "Text",
      "date": "Date",
      "dropdown": "Multiple Choices",
      "optional": "Optional",
      "public": "Public",
      "private": "Private",
      "addNew": "Add new",
      "editCreateServices": "Edit custom field",
      "name": "Field name",
      "invalidName": "Invalid name",
      "type": "Field type",
      "invalidType": "Invalid type",
      "showOnBookingPage": "Public field",
      "showOnBookingPageDesc": "Visible on your booking page",
      "mandatory": "Required field",
      "mandatoryDesc": "For clients (online bookings)",
      "confirmDeleteField": "Are you sure you want to delete this custom field?",
      "dropdownValues": "Options (one option per line)",
      "invalidDropdownValues": "Invalid options",
      "alertMsg1": "Do not add the fields VAT, Date of Birth, and Gender here.",
      "alertMsg2": "You can add them in \"More options\" on your booking page,",
      "alertMsg3": "click here."
    },
    "marketingModal": {
      "no": "No, thanks",
      "usePromo": "Use promotion"
    }
  },
  "GENERAL": {
    "here": "here",
    "invalidValue": "Invalid value",
    "downloading": "Downloading...",
    "download": "Download",
    "filters": "Filters",
    "all": "All",
    "salesExport": "sales",
    "pay": "Pay",
    "paid": "Paid",
    "invoice": "Invoice",
    "receipt": "Receipt",
    "creditNote": "Credit Note",
    "step": "Step",
    "of": "of",
    "options": "Options",
    "date": "Date",
    "state": "Status",
    "generalErrorMsg": "Something went wrong. Please try again.",
    "chooseOption": "Choose an option",
    "error": "Something went wrong. Please try again.",
    "retry": "Retry",
    "email": "Email",
    "phone": "Phone number",
    "invalidEmail": "Invalid email",
    "password": "Password",
    "continue": "Continue",
    "requiredField": "Required",
    "with": "with",
    "total": "Total",
    "signupCta": "Sign Up for Free",
    "services": "Services",
    "schedule": "Schedule",
    "resource": "Staff member",
    "resources": "Staff members",
    "price": "Price",
    "remove": "Remove",
    "upload": "Upload",
    "save": "Save",
    "saveDraft": "Save draft",
    "updateDraft": "Update draft",
    "cancel": "Cancel",
    "configure": "Configure",
    "savedSuccessfully": "Saved Successfully!",
    "deletedSuccessfully": "Deleted Successfully!",
    "changesNotSaved": "The changes have not been saved.",
    "edit": "Edit",
    "editServices": "Edit services",
    "fileTypeNotSupported": "File type not supported",
    "storeTypes": {
      "agenda": "Calendar",
      "store": "Store",
      "salon": "Salon",
      "center": "Center",
      "clinic": "Clinic",
      "office": "Office",
      "agency": "Agency",
      "local": "Place"
    },
    "merchantTypes": {
      "optical": "Optical Center",
      "psychology": "Psychology",
      "nutricionist": "Nutricionist",
      "hairsalon": "Hair Salon",
      "barber": "Barber Shop",
      "beautySalon": "Beauty Salon",
      "spaMassages": "Spa/Massages",
      "personalTrainer": "Personal Trainer",
      "physiotherapy": "Physiotherapy",
      "dentist": "Dentist",
      "veterinarian": "Veterinarian",
      "petService": "Pet Service",
      "photography": "Photography",
      "realEstate": "Real Estate",
      "consultancy": "Consultancy",
      "advocacy": "Advocacy",
      "tutorMentor": "Tutor/Mentor",
      "sports": "Sports",
      "other": "Other",
      "nailsArtists": "Nails",
      "makeupArtists": "Makeup",
      "lashesArtists": "Lashes",
      "osteopath": "Osteopath",
      "clinic": "Clinic",
      "aesthetic": "Aesthetic",
      "holisticTeraphy": "Holistic Teraphy",
      "tattooArtists": "Tattoos",
      "pharmacy": "Pharmacy",
      "fitness": "Fitness",
      "auto": "Auto"
    },
    "new": "New",
    "no": "No",
    "yes": "Yes",
    "month": "month",
    "months": "months",
    "week": "week",
    "weeks": "weeks",
    "year": "year",
    "areYouSure": "Are you sure?",
    "cookieConsent": "We use cookies to improve user experience, and analyze website traffic. For these reasons, we may share your site usage data with our social media, and analytics partners. By clicking \"Accept Cookies\" you consent to store on your device all the technologies described in our",
    "cookieConsentBtn": "Accept Cookies",
    "back": "Back",
    "close": "Close",
    "gender": {
      "male": "Male",
      "female": "Female",
      "other": "Other"
    },
    "validators": {
      "invalidPortugueseVat": "Invalid NIPC/NIF for Portugal (for international numbers, use the country code, e.g., FR12345678901)",
      "invalidSpanishVat": "Invalid NIF for Spain (for international numbers, use the country code, e.g., FR12345678901)"
    },
    "advancedOptions": "Advanced options",
    "walkInCustomer": "Walk-in customer"
  },
  "MARKETING": {
    "newCampaign": "Create Campaign",
    "campaigns": "Campaigns",
    "processing": "Processing",
    "sent": "Sent",
    "client": "client",
    "clients": "clients",
    "content": "Content",
    "editContent": "Edit content",
    "pageTitleSms": "Text campaign",
    "pageTitleEmail": "E-mail campaign",
    "campaignType": "Campaign type",
    "storesPlaceholder": "All stores",
    "titleLabel": "Campaign Name",
    "titlePlaceholder": "Campaign Name",
    "titleError": "Invalid Name",
    "fromEmailPlaceholder": "Who will send this email?",
    "fromEmailError": "Invalid From",
    "subjectLabel": "Subject",
    "subjectPlaceholder": "Message Subject",
    "subjectError": "Invalid Subject",
    "senderLabel": "From",
    "senderPlaceholder": "From",
    "senderError": "The sender is invalid. Maximum 11 characters without spaces, numbers and symbols.",
    "templateTitle": "Title",
    "templateText": "Text",
    "templateShowCover": "Show header imagem",
    "templateShowCTA": "Show CTA button",
    "templateCtaText": "Button text",
    "templateCtaLink": "Button link",
    "templateLabel": "Message",
    "templatePlaceholder": "Write your message",
    "templateError": "Invalid Message",
    "characters": "Characters",
    "test": "Send Test",
    "sendCampaign": "Send Campaign",
    "send": "Send",
    "presets": {
      "allTitle": "All clients",
      "allSubTitle": "Full list of clients",
      "activeTitle": "Active clients",
      "activeSubTitle": "Clients with bookings on the last {{months}} months",
      "activeSubTitle2": "Clients with bookings",
      "activeSubTitle3": "Clients with bookings on the last",
      "newTitle": "New clients",
      "newSubTitle": "Clients that made the first booking in the last 30 days",
      "oldTitle": "Inactive Clients",
      "oldSubTitle": "Clients without bookings on the last {{months}} months",
      "oldSubTitle2": "Clients without bookings",
      "oldSubTitle3": "Clients without bookings on the last"
    },
    "testSent": "Test sent successfully",
    "exclude": "Exclude",
    "excludeContact": "Exclude contact",
    "excludeContactConfirm1": "Do you want to exclude",
    "excludeContactConfirm2": "only from this campaign or also from future communications?",
    "excludeContactBtnThis": "Only from this campaign",
    "excludeContactBtnAll": "From this campaign and future communications",
    "contactImport": "Send us an email if you wish to import your client's list: <br/>",
    "sendDate": "Send date",
    "campaignCost": "Campaign cost",
    "errorNoClients": "You need to choose a group of clients first.",
    "marketingConsentInfo": "Only clients who have accepted to receive marketing campaigns are shown in this list.",
    "defaultSubject": "Email subject",
    "defaultTitle": "Campaign title",
    "defaultCtaCopy": "Book now",
    "defaultText": "Your compaign content here...",
    "defaultSms": "Your message here...",
    "tableCampaign": "Campaign",
    "tableSent": "Sent",
    "tableDate": "Date",
    "tableROI": "Return on Investment",
    "tableBookings": "bookings",
    "tableBooking": "booking",
    "tableCost": "Cost",
    "tableStatus": "Status",
    "subtitle": "Send updates or promotions to all your customers",
    "balanceBanner": "Enjoy a ${{balance}} discount on your next campaign",
    "senderStatusApproved": "Approved",
    "senderStatusPending": "Pending approval",
    "senderStatusRejected": "Rejected",
    "senderStatusFallbackNote": "While not approved, SMS will be sent from the \"BUK\" sender name. You can change it in",
    "senderStatusApprovedNote": "You can change it in",
    "senderStatusRejectedNote": "This sender name was rejected. Try a different name. In the meantime, SMS will be sent from the \"BUK\" sender name. You can change it in",
    "senderStatusLink": "notification settings",
    "senderFreePlanNote": "Upgrade to Pro to customize your SMS sender name.",
    "senderFreePlanGeneric": "BUK",
    "chooseTemplate": "Choose one of these templates",
    "newSuggestion": "New suggestion",
    "confirmModal": {
      "title": "Send campaign",
      "clients": "Clients",
      "price": "Price",
      "priceMin": "Minimum campaign price",
      "priceCredit": "${{balance}} credit applied!",
      "choosePayment": "Choose a payment method:",
      "btnCard": "Card",
      "btnMbway": "MBWay",
      "btnMbwayMsg": "You will get a notification on your phone to validate the payment",
      "changeCard": "Change card",
      "useSelectedCard": "Use default card",
      "stateMbwayTitle": "Open MBWay to accept the payment",
      "stateMbwayText": "Payment request sent to: ",
      "stateSendingTitle": "Setting up your campaign...",
      "stateSendingText": "Wait a moment please",
      "stateSuccessTitle": "Campaign sent!",
      "stateSuccessText": "Your customers will get your campaign over the next minutes.",
      "stateSuccessBtn": "Back to marketing",
      "cancel": "Cancel",
      "sendNow": "Send now"
    }
  },
  "CONFIRM_DRAG": {
    "cancel": "Cancel",
    "confirm": "Confirm",
    "change_booking": "Change booking",
    "change_holiday": "Change block",
    "before": "Before",
    "now": "Now",
    "notify_client": "Notify client"
  },
  "ACCOUNT": {
    "hi": "Hi",
    "basic_info": "Basic information",
    "first_last_name": "First and last nmae",
    "email": "E-mail",
    "password": "Password",
    "current_password": "Current password",
    "new_password": "New password",
    "account_notifications": "Account notifications",
    "new_booking": "New booking email",
    "new_booking_desc": "Everytime a customer books a new appointment",
    "notify_only_provider": "Receive notifications from:",
    "notify_only_provider_desc": "Receive emails and notifications only for this collaborator's bookings",
    "notify_all_providers": "All collaborators",
    "payment_confirmation": "Payment confirmed email",
    "payment_confirmation_desc": "When a client completes payment for an admin-created booking",
    "push_new_booking": "New booking notification",
    "push_new_booking_desc": "Everytime a customer books a new appointment",
    "canceled_booking": "Booking canceled email",
    "canceled_booking_desc": "Everytime a customer cancels an appointment",
    "push_canceled_booking": "Booking canceled notification",
    "push_canceled_booking_desc": "Everytime a customer cancels an appointment",
    "otherOptions": "Other Options",
    "language": "Select a language"
  },
  "SUBSCRIPTION": {
    "subscriptionTitle": "Your Subscription",
    "next_payment": "Next payment",
    "providers": "provider(s)",
    "discount": "Discount",
    "total": "Total",
    "card": "Card",
    "direct_debit": "Direct Debit",
    "payment_method": "Payment method",
    "edit": "Edit Subscriptions",
    "invoices": "View Invoices",
    "without_sms": "Without SMS",
    "proPlan": "Pro Plan",
    "proPlusPlan": "Pro+ Plan",
    "plansVAT": "Price includes taxes"
  },
  "INVOICES": {
    "desc": "Your invoices will be available at the beginning of the following day",
    "invoice_data": "Invoicing details",
    "company_name": "Legal name (optional)",
    "company_vat": "VAT Number",
    "name": "Name",
    "date": "Date",
    "value": "Value",
    "emptyState": "No invoices available to show"
  },
  "SIGNUP": {
    "testimonial": {
      "benefitsTitle": "Why use BUK?",
      "benefitsList": [
        "Team and customer management",
        "Unlimited text reminders",
        "Send Email and Text Campaigns",
        "Customized booking page",
        "Increase Your Google Reviews",
        "Credit Card/Apple/Google Payments"
      ],
      "quote": "\"BUK is easy to use, super interactive, practical and functional, allowing you to work in a more organized and professional way.\"",
      "author": "David Frazão — Bento Barbershops"
    }
  },
  "SETUP_GUIDE": {
    "create_account": "Create your account",
    "configure_business": "Configure your business",
    "add_your_schedule": "Add your schedule",
    "add_your_services": "Add your services",
    "create_first_appointment": "Create your first appointment",
    "setup_booking_page": "Setup your booking page",
    "import_clients": "Import your clients",
    "win_10_eur": "Win 10€",
    "stepsLeft": "Only {{steps}} steps left",
    "stepLeft": "Only {{steps}} step left",
    "extraReady": "Get extra ready ⚡️",
    "almostReady": "You are almost ready!",
    "noThankYou": "No, thank you!",
    "extraStepLeft": "Only {{steps}} extra step left ⚡️",
    "extraStepsLeft": "Only {{steps}} extra steps left ⚡️ ⚡️",
    "titleSuccess": "Great, you reached 100%! 🎉",
    "descSuccess": "Now that you already know the basic settings, it's time to meet and customize your booking page.",
    "ctaSuccess": "Customize now"
  },
  "NPS": {
    "question": "On a scale from 0 to 10, how likely would you recommend BUK to a friend or colleague?",
    "subtitle": "0 - Unlikely / 10 - Very likely",
    "thanks": "Thank you for your feedback!",
    "btn1": "Close",
    "btn2": "Rate now!",
    "inviteModalTitle": "Invite friends to BUK",
    "inviteModalSubtitle": "Offer a 50% discount to your friends and earn €50 in Marketing credits and €50 in subscription credit.",
    "reviewBukOnGoogle": "Leave us a review on Google and help others find us!",
    "inviteYourFriends": "Invite your friends and earn €100",
    "btnRef": "Invite Friends"
  },
  "CANCEL_XP": {
    "title": "Cancel Subscription",
    "warning": "Attention, you will lose access to your account and your clients' data.",
    "warning_account": "You will not be able to access your account",
    "warning_clients": "You will not be able to access your clients' data",
    "keep_access": "To maintain access to your account, you must switch to the Free plan in 'Edit Subscription'",
    "back": "Go back",
    "continue": "Continue",
    "subtitle": "Choose an option",
    "subtitle_improvements": "Help us understand how we can improve our service",
    "subtitle_competitors": "Which system will you adopt?",
    "subtitle_promo": "We would like to offer you 3 months at 50% discount. Would you be interested?",
    "title_leaving": "We are sad to see you go...",
    "pricing_before": "BEFORE",
    "pricing_now": "NOW",
    "btn_accept": "Accept promotion",
    "btn_reject": "Do not accept and cancel",
    "changeSoftware": "I switched software",
    "closing": "Business is closing",
    "temporaryClose": "I'm temporarily closing",
    "personalReason": "Personal reasons",
    "notAdequate": "BUK doesn't have what I need",
    "other": "Other",
    "price": "Better price",
    "features": "More features",
    "support": "Better technical support",
    "performance": "Fewer bugs",
    "noSoftware": "None"
  },
  "GOOGLE_PLACE": {
    "input": "Search for your business"
  },
  "CREATE_MERCHANT": {
    "googleQuestion": "Is your business on Google?",
    "googleNotes": "We only use this information to automatically fill in details such as hours and services, saving you time when creating your account.",
    "skipStep": "Skip this step",
    "confirm": "Confirm"
  },
  "SALES_LIST_PAGE": {
    "sales": "Sales",
    "payments": "Payments",
    "commissions": "Commissions",
    "filterFieldPlaceholder": "Filter by Name / VAT / Invoice",
    "allUsers": "All",
    "state": "Status",
    "paid": "Paid",
    "cancelled": "Cancelled",
    "toPay": "To pay",
    "totalCommissions": "Commissions",
    "totalAmountWithoutCommissions": "Total w/o Commissions",
    "emptyState": {
      "title": "No sales",
      "description": "There are no sales to show."
    },
    "invoice": "Invoice",
    "salesCode": "Sale",
    "nameVat": "Name / VAT",
    "registeredBy": "Registered by",
    "totalValue": "Total value",
    "downloadAll": "Download all invoices",
    "exportXLS": "Export (XLS)",
    "seeDetails": "View details",
    "emailInvoice": "Send invoice",
    "downloadInvoice": "Download invoice",
    "paymentMethod": "Payment method",
    "paymentsCount": "Payment(s)",
    "continueDraft": "Continue draft",
    "deleteDraft": "Delete draft",
    "deleteDraftConfirm": "Are you sure you want to delete this draft? This action cannot be undone."
  },
  "INVOICING_SERVICE": {
    "dateRanges": {
      "today": "Today",
      "yesterday": "Yesterday",
      "thisWeek": "This week",
      "lastWeek": "Last week",
      "thisMonth": "This Month",
      "lastMonth": "Last Month",
      "thisYear": "This Year",
      "firstQuarter": "1st Quarter",
      "secondQuarter": "2nd Quarter",
      "thirdQuarter": "3rd Quarter",
      "fourthQuarter": "4th Quarter",
      "untilNow": "Until now",
      "custom": "Custom",
      "nextWeek": "Next week",
      "nextMonth": "Next month",
      "fromNow": "From now"
    }
  },
  "SALES_STATUS": {
    "paid": "Paid",
    "pending": "Pending",
    "cancelled": "Cancelled",
    "draft": "Draft",
    "uninvoiced": "Uninvoiced"
  },
  "DATE_RANGE_MODAL": {
    "title": "Choose 2 dates",
    "dateInit": "Start date",
    "dateEnd": "End date",
    "filter": "Filter",
    "dateFormat": "dd/mm/yyyy"
  },
  "PAYMENTS_LIST_PAGE": {
    "emptyState": {
      "title": "No payments",
      "description": "There are no payments to show."
    },
    "invoice": "Invoice",
    "nameVat": "Name / VAT",
    "registeredBy": "Registered by",
    "paymentMethod": "Payment Method",
    "value": "Value",
    "bukPay": "Stripe",
    "salesCode": "Sale",
    "paymentsOnline": "Online"
  },
  "INVOICE_PAYMENT_METHOD": {
    "title": "Invoice",
    "clientSection": "Billing Information",
    "vat": "VAT number",
    "name": "Name",
    "cae": "CAE",
    "payLaterDescription": "Invoice now, but receive payment later",
    "partialPayDescription": "Invoice and receive only part of the sale amount",
    "fullPayDescription": "Invoice and receive the full sale amount",
    "payLaterTitle": "An unpaid sale will be registered",
    "payLaterList1": "It will register a debt for the selected client",
    "payLaterList2": "To clear this debt later, you can check the patient file or the Sales section",
    "payNow": "Pay now",
    "partialPaymentMissing": "Will be registered as unpaid",
    "paymentMethod": "Payment Method",
    "paymentMethodRequired": "Pick at least one payment method",
    "valueByPaymentMethod": "Amount by payment method",
    "value": "Value",
    "paymentSumError": "The sum of the payments must equal the total to be paid",
    "descriptionLabel": "Notes",
    "descriptionPlaceholder": "Enter notes about the sale",
    "descriptionError": "Invalid notes, maximum 200 characters",
    "doInvoice": "Invoice",
    "doSale": "Register",
    "saveDraft": "Save draft",
    "resumeDraftTitle": "Resume draft",
    "draftSavedBy": "saved by {{name}} on {{date}}",
    "payment": "Payment",
    "card": "Card",
    "cash": "Cash",
    "mbway": "MB Way",
    "mbref": "Multibanco",
    "transfer": "Bank Transfer",
    "other": "Other",
    "full": "Pay in full",
    "partial": "Partial payment",
    "later": "Pay later",
    "onlineApplePay": "Online (Apple Pay)",
    "onlineGooglePay": "Online (Google Pay)",
    "onlineCCard": "Online (Credit Card)",
    "onlineMbway": "Online (MB Way)",
    "onlineMbref": "Online (Multibanco)",
    "teya": "Teya Terminal",
    "continueToTerminal": "Continue to the Terminal"
  },
  "COMMISSIONS_LIST_PAGE": {
    "totalCommission": "Total Commission",
    "emptyState": {
      "title": "No commissions found",
      "description": "There are no commissions to display at the moment."
    },
    "sale": "Sale",
    "nameVat": "Client",
    "serviceProduct": "Service",
    "totalWithVat": "Total with VAT",
    "commissionWithVat": "Commission with VAT"
  },
  "INVOICE_PREVIEW": {
    "creditNote": "Cancel (CN)",
    "cancelSale": "Cancel sale",
    "pay": "Pay",
    "summary": "Summary",
    "discount": "Global Discount",
    "subTotal": "Subtotal",
    "totalVAT": "VAT",
    "sendPaymentLink": "Send payment link",
    "editPayments": "Edit Payments",
    "emptyState": "Add a service or product to get started.",
    "seeDetails": "See details",
    "bookingDate": "Booking",
    "bookingOpenFailed": "We couldn’t open this booking. It may have been deleted or is no longer visible on the calendar.",
    "editSale": "Edit",
    "editingExistingSale": "It is not possible to edit items that have already been registered. To correct an error, please cancel this sale.",
    "invoiceRemaining": "Invoice Remaining",
    "doInvoice": "Invoice",
    "cancelOldInvoiceWarning": "When invoicing, a Credit Note will be issued for the deposit amount and a new invoice for the total amount.",
    "atLeastOneItemMustHavePrice": "To create a sale with a zero total, add an amount and a 100% discount."
  },
  "INVOICING_PAGE": {
    "registerSale": "Register Sale",
    "registerPayment": "Register Payment"
  },
  "INVOICE_ADD_ITEMS": {
    "addPatientTitle": "Add Patient",
    "addPatientDescription": "Choose a patient (optional)",
    "title": "What do you want to register?",
    "searchPlaceholder": "Filter by name",
    "emptyServicesTitle": "No services found",
    "emptyServicesDescription": "No services available to display.",
    "emptyProductsTitle": "No products found",
    "emptyProductsDescription": "No products available to display.",
    "services": "Services",
    "products": "Products"
  },
  "PATIENT_SELECTOR": {
    "patientName": "Patient Name",
    "searchPlaceholder": "Search by name, VAT, or phone",
    "patientNotFound": "Patient not found",
    "search": "Search",
    "createNewPatient": "Create New Patient"
  },
  "INVOICE_ITEM_EDIT_MODAL": {
    "title": "Edit Item",
    "quantity": "Quantity",
    "unitPrice": "Price",
    "discount": "Discount",
    "vatRate": "VAT",
    "vatExemption": "Exemtion reason",
    "hasProviders": "Associate professional(s)",
    "provider": "Professional",
    "commission": "Commission",
    "addProvider": "Add professional"
  },
  "INVOICE_DISCOUNT_MODAL": {
    "discountPercentageInvalid": "Invalid discount. Must be between 0% and 100%.",
    "discountAmountCentsInvalid": "Invalid discount amount. Must be between 0 and the total invoice amount.",
    "title": "Global Discount",
    "valueToPay": "Amount to pay",
    "discount": "Discount"
  },
  "SALE_DETAILS": {
    "headerTitle": "Sale",
    "registeredBy": "Registered by",
    "documents": "Documents",
    "history": "History",
    "missingPayment": "Missing Payment",
    "canceled": "Canceled",
    "summary": "Summary",
    "partialInvoice": "Pre-payment",
    "tip": "Tip"
  },
  "INVOICE_SUCCESS": {
    "success": "Sale registered successfully!",
    "conclude": "Done",
    "goToStart": "Go to start",
    "goToSales": "Go to sales",
    "openSaleDetails": "View sale details",
    "emailInvoice": "Email invoice",
    "printInvoice": "Print invoice",
    "downloadInvoice": "Download invoice",
    "printTicket": "Print receipt ticket",
    "moreOptions": "More options",
    "goToPayments": "Go to payments",
    "invoiceFailedTitle": "Failed to generate invoice",
    "invoiceFailedDescription": "The sale was registered but the invoice was not issued. To issue the invoice for this sale, visit the Sales page.",
    "paymentFailedTitle": "Payment failed",
    "paymentFailedDescription": "The sale was registered, but the payment was not completed. You can retry the payment."
  },
  "EDIT_COMMISSION_MODAL": {
    "title": "Edit Commission"
  },
  "CANCEL_INVOICE_MODAL": {
    "titleInvoice": "Issue Credit Note",
    "descriptionInvoice": "Caution, this action cannot be undone. A credit note will be generated for the total invoice amount.",
    "title": "Cancel sale",
    "description": "Caution, this action cannot be undone.",
    "reasonLabel": "Reason",
    "reasonPlaceholder": "Write a reason",
    "cancel": "Close",
    "paymentsWarning": "You must process the refund manually.",
    "refundPaymentMethodLabel": "Refund Payment Method",
    "refundPaymentMethodPlaceholder": "Select payment method",
    "refundPaymentMethodRequired": "Select a refund payment method"
  },
  "REPLACE_INVOICE_MODAL": {
    "title": "Cancel and Correct Sale",
    "description": "This sale will be canceled and its content will be copied to a new one.",
    "descriptionInvoice": "Attention: this action cannot be undone.",
    "warningMessage": "Attention: this sale has associated invoices. A Credit Note will be issued automatically.",
    "descriptionNoInvoice": "This action cannot be undone.",
    "back": "Go Back",
    "cancelSale": "Cancel Sale",
    "cancelledSuccessfully": "Sale canceled successfully!"
  },
   "INVOICING_SETTINGS": {
    "setupHeader": "To access the invoicing module, we just need you to send us some information",
    "merchantName": "Registration Name",
    "vatNumber": "Entity VAT",
    "address": "Address",
    "city": "City",
    "postalCode": "Postal Code",
    "sendRequest": "Send Request",
    "askForHelp": "Talk to us",
    "autoridadeTributaria": "Software Certified by the Tax Authority Nº2578.",
    "header": "Simplify your invoicing and save time managing your business",
    "description": "Issue invoices automatically and organized, without complications. Always have control of your sales and payments in one place.",
    "configurations": "Configurations",
    "invoicingData": "Invoicing Data",
    "communicationWithAT": "Configure communication with AT",
    "legalRequirement": "To use the invoicing system, it is legally required to activate communication with the AT.",
    "atPortal": "Portal das Finanças",
    "createAtUser": "Create a new user in the Portal das Finanças.",
    "addAtUser": "Add User",
    "activateCommunication": "Activate Communication",
    "addUserToBUK": "Add the new user to BUK.",
    "atCredentials": "Credentials",
    "atCredentialsUser": "Tax Authority user",
    "atSectionTitle": "Tax Authority",
    "atSectionDescription": "Configure your access and communication",
    "authenticate": "Authentication",
    "saftTitle": "SAF-T Files",
    "downloadSaft": "Download SAF-T",
    "viewAtCommunications": "View AT communications",
    "atCommunications": "Communications with the Tax Authority",
    "communicationType": "Type",
    "communicationInfo": "Details",
    "communicationResult": "Result",
    "communicationSuccess": "Success",
    "communicationError": "Error",
    "noAtCommunications": "No communications found",
    "atCommunicationTypeSaft": "SAF-T",
    "atCommunicationTypeGt": "Transport document",
    "previousPage": "Previous",
    "nextPage": "Next",
    "autoSendSaft": "Automatically communicate with the AT (on the 2nd of every month)",
    "autoCommunication": "Automatic communication",
    "autoCommunicationDay": "Day 2 of every month",
    "communicationsList": "Communications list",
    "communicationsListDescription": "Check communications with the Tax Authority",
    "consultCommunications": "View",
    "deactivate": "Deactivate",
    "activate": "Activate",
    "logoRecommendedSize": "jpg, png (Rec. size: 384x128px)",
    "year": "Year",
    "month": "Month",
    "authoritySiteDescription1": "Access the Portal das Finanças to create a user",
    "authoritySiteDescription2": "Username can use <b>“BUK”</b>",
    "authoritySiteDescription3": "Choose a secure password, and add the following permissions: <b>WFA</b> (Invoicing Communication), <b>WSE</b> (Series Communication).",
    "authoritySiteDescription4": "Click <b>Submit</b>",
    "openAuthoritySite": "Access the Portal das Finanças",
    "closeAndContinue": "Close and continue",
    "askForAccess": "Request access",
    "emailAddress": "Email"
  },
  "ACTIVATE_INVOICING_AUTHORITY": {
    "img": "Tax Authority",
    "title": "Activate Communication",
    "titleReconfigure": "Update AT credentials",
    "description": "Fill in the username and password previously created in the Portal das Finanças.",
    "descriptionReconfigure": "Enter the username and password from the Tax Authority Portal.",
    "userDescription": "In Portal das Finanças, the username format is {{vatNumber}}/number (e.g. {{vatNumber}}/1). Enter below only the number assigned to the new user.",
    "userLabel": "Username",
    "userPlaceholder": "E.g. 1",
    "userInvalid": "Enter the user number assigned in Portal das Finanças.",
    "passwordLabel": "Password",
    "passwordPlaceholder": "Enter the password",
    "newAccountWarning": "If you have just created this user in Portal das Finanças, it can take several minutes before they become available for activation. If the request fails or times out, try again after about 5 minutes.",
    "send": "Activate Communication"
  },
  "UPLOAD_INVOICING_LOGO": {
    "title": "Logo",
    "fileType": "jpg, png (min. 640x640px)",
    "upload": "Upload",
    "reset": "Remove"
  },
  "EMAIL_INVOICE_MODAL": {
    "successTitle": "Sent successfully!",
    "successMessage": "Documents sent successfully.",
    "title": "Confirm email",
    "emailLabel": "Email",
    "emailPlaceholder": "Email to send the invoice to",
    "send": "Send now"
  },
  "CLIENT_SALES": {
    "emptyState": {
      "title": "No sales",
      "description": "There are no sales to display."
    }
  },
  "REPORTS_LIST": {
    "title": "Reports",
    "generalReport": "General Report",
    "generalReportDesc": "Summary of the main metrics of your business",
    "explore": "Explore",
    "sectionSales": "Sales",
    "sectionCommissions": "Commissions",
    "sectionPayments": "Payments",
    "sectionBookings": "Bookings",
    "sectionClients": "Clients",
    "sectionCommunication": "Communication"
  },
  "CALENDAR_TOOLTIP_TEMPLATE": {
    "reason": "Reason",
    "provider": "Provider",
    "schedule": "Schedule",
    "patient": "Client",
    "service": "Service",
    "roomEquipment": "Room/Equipment",
    "roomOccupied": "Occupied",
    "notes": "Notes",
    "noShow": "No Show",
    "confirmed": "Confirmed",
    "arrived": "Arrived",
    "cancelled": "Cancelled",
    "prepaymentInvoice": "Prepayment Invoice",
    "invoice": "Invoice",
    "sale": "Sale"
  },
  "REPORTS_SERVICE": {
    "salesSummaryTitle": "Items Sold",
    "salesSummaryDescription": "Description of the Sales Summary",
    "salesTotalsTitle": "Sales Totals",
    "salesTotalsDescription": "Description of the Sales Totals",
    "salesMonthlyTitle": "Monthly Sales",
    "salesMonthlyDescription": "Sales grouped by month with billing and payment totals.",
    "taxesSummaryTitle": "Taxes summary",
    "taxesSummaryDescription": "Summary of all tax-related transactions.",
    "vatRatesFilterLabel": "Tax rate",
    "vatRatesFilterPlaceholder": "Select tax rates",
    "saleStatusFilterLabel": "Sale Status",
    "saleStatusFilterPlaceholder": "Select the sale status",
    "invoiceStatusFilterLabel": "Invoice Status",
    "invoiceStatusFilterPlaceholder": "Select the invoice status",
    "createdByUserFilterLabel": "Created by User",
    "createdByUserFilterPlaceholder": "Select the user who created",
    "providerFilterLabel": "Provider",
    "providerFilterPlaceholder": "Select the provider",
    "providersFilterLabel": "Providers",
    "providersFilterPlaceholder": "Select the providers",
    "saleItemTypeFilterLabel": "Sale Item Type",
    "saleItemTypeFilterPlaceholder": "Select the sale item type",
    "salesListTitle": "Sales list",
    "salesListDescription": "Complete listing of all individual sales transactions.",
    "paymentsListTitle": "Payments list",
    "paymentsListDescription": "Complete listing of all individual payments.",
    "paymentsSummaryTitle": "Payments by method",
    "paymentsSummaryDescription": "Payment totals grouped by payment method.",
    "onlinePaymentsListTitle": "Online payments list",
    "onlinePaymentsListDescription": "Online prepayments made at booking time.",
    "upfrontPaymentsSummaryTitle": "Upfront payments by month",
    "upfrontPaymentsSummaryDescription": "Analysis of prepayments and deposits over a selected time period.",
    "tipsMonthlyTitle": "Teya tips by month",
    "tipsMonthlyDescription": "Total tips received via Teya terminal, grouped by month.",
    "commissionsListTitle": "Commissions list",
    "commissionsListDescription": "Complete listing of all individual commission transactions.",
    "commissionsSummaryTitle": "Commission summary",
    "commissionsSummaryDescription": "Overview of commissions earned by team members, locations, and sale items.",
    "paymentMethodFilterLabel": "Payment method",
    "paymentMethodFilterPlaceholder": "Select the payment method",
    "bookingsListTitle": "Appointments list",
    "bookingsListDescription": "Full list of all scheduled appointments.",
    "bookingsSummaryTitle": "Appointments summary",
    "bookingsSummaryDescription": "General overview of appointment trends, cancellations and no-shows.",
    "cancellationsNoshowSummaryTitle": "Cancellations & no-shows by month",
    "cancellationsNoshowSummaryDescription": "Insight into appointment cancellations and no-shows to identify patterns.",
    "workingHoursSummaryTitle": "Working hours summary",
    "workingHoursSummaryDescription": "Overview of operational hours and productivity.",
    "incidentTypeFilterLabel": "Type",
    "incidentTypeFilterPlaceholder": "Select the type",
    "incidentTypeBoth": "Cancellations and no-shows",
    "incidentTypeCancellations": "Cancellations",
    "incidentTypeNoshows": "No-shows",
    "cancelledByFilterLabel": "Cancelled by",
    "cancelledByFilterPlaceholder": "Select who cancelled",
    "cancelledByAll": "All",
    "cancelledByClient": "Client",
    "cancelledByBusiness": "Business",
    "periodTypeFilterLabel": "Period",
    "periodTypeFilterPlaceholder": "Select grouping",
    "periodTypeDay": "Day",
    "periodTypeWeek": "Week",
    "periodTypeMonth": "Month",
    "bookingsByProviderTitle": "Appointments by provider",
    "bookingsByProviderDescription": "Number of appointments grouped by provider.",
    "bookingsByProviderServiceTitle": "Appointments by provider and service",
    "bookingsByProviderServiceDescription": "Number of appointments grouped by provider and service.",
    "clientsListTitle": "Clients list",
    "clientsListDescription": "List of clients with booking and cancellation statistics.",
    "clientsSummaryTitle": "Client summary",
    "clientsSummaryDescription": "Overview of client base, acquisition, and retention metrics.",
    "clientTypeFilterLabel": "Client type",
    "clientTypeFilterPlaceholder": "Select the client type",
    "clientTypeAll": "All",
    "clientTypeNew": "New",
    "clientTypeReturning": "Returning",
    "clientsBirthdaysTitle": "Birthdays",
    "clientsBirthdaysDescription": "Clients with birthdays in the selected period.",
    "smsListTitle": "Sent SMS",
    "smsListDescription": "List of sent SMS messages with delivery status.",
    "bookingStatusFilterLabel": "Status",
    "bookingStatusFilterPlaceholder": "Select appointment statuses",
    "bookingStatusScheduled": "Scheduled",
    "bookingStatusCompleted": "Completed",
    "servicesFilterLabel": "Services",
    "servicesFilterPlaceholder": "Select services",
    "categoriesFilterLabel": "Categories",
    "categoriesFilterPlaceholder": "Select categories"
  },
  "SALE_ITEM_TYPE": {
    "all": "All",
    "service": "Service",
    "product": "Product",
    "other": "Other"
  },
  "INVOICE_STATUS": {
    "invoiced": "Invoiced",
    "uninvoiced": "Uninvoiced",
    "partiallyInvoiced": "Partially Invoiced"
  },
  "REPORT_PAGE": {
    "emptyState": {
      "title": "No data",
      "description": "There is no data to display."
    },
    "filterFieldPlaceholder": "Search...",
    "downloadCsvError": "Unable to generate CSV file. Please try again later.",
    "downloadCsv": "Download"
  },
  "REPORTS_TABLE": {
    "saleItem": "Item",
    "category": "Category",
    "itemType": "Item Type",
    "quantity": "Quantity",
    "grossSales": "Gross Sales",
    "discounts": "Discounts",
    "netSales": "Net Sales",
    "tax": "Tax",
    "total": "Total",
    "totalColumnTitle": "Metric",
    "totalColumnValue": "Value",
    "saleReference": "Sale",
    "clientName": "Name",
    "clientNamePhone": "Name / phone",
    "createdByUserName": "Registered by",
    "createdAt": "Date",
    "saleDate": "Date",
    "monthStart": "Month",
    "salesCount": "Sales count",
    "paidAmountCents": "Amount paid",
    "pendingCents": "Amount pending",
    "subtotalCents": "Subtotal (excl. VAT)",
    "vatCents": "VAT",
    "taxName": "Tax name",
    "taxRate": "Tax rate",
    "taxableAmountCents": "Taxable amount",
    "taxCollectedCents": "Tax collected",
    "totalWithTaxCents": "Total with tax",
    "transactionCount": "Transaction count",
    "periodLabel": "Month",
    "paymentsCollectedCount": "Payments collected",
    "amountCollectedCents": "Amount collected",
    "totalCancelled": "Total canc.",
    "cancellationRatePercent": "Canc. rate",
    "cancelledByClient": "Canc. by client",
    "cancelledByBusiness": "Canc. by business",
    "totalNoShows": "Total no-shows",
    "noshowRatePercent": "No-show rate",
    "lostRevenueCents": "Lost revenue",
    "mostCancelledService": "Most cancelled service",
    "mostNoShowClient": "Most no-show client",
    "totalCents": "Total value",
    "saleStatusLabel": "Status",
    "paymentMethod": "Payment method",
    "paymentCount": "Payments count",
    "tipCount": "Tips count",
    "tipCents": "Tips",
    "amountCents": "Value",
    "paidAt": "Payment date",
    "totalAmountPaidCents": "Total amount paid",
    "priceToMerchant": "Merchant amount",
    "priceToBuk": "BUK commission",
    "clientEmail": "Email",
    "clientPhone": "Phone",
    "providerName": "Provider",
    "totalSalesCents": "Total sales",
    "totalCommissionsCents": "Total commissions",
    "commissionRateAvgPercent": "Commission rate",
    "servicesCommissionCents": "Services commission",
    "productsCommissionCents": "Products commission",
    "availableHours": "Available hours",
    "bookedHours": "Booked hours",
    "unbookedHours": "Unbooked hours",
    "utilizationRatePercent": "Utilization rate",
    "revenuePerHourCents": "Revenue per hour",
    "serviceName": "Service / Product",
    "serviceTotalCents": "Total (incl. VAT)",
    "commissionAmountCents": "Commission (incl. VAT)",
    "dateInit": "Date & Time",
    "durationMinutes": "Duration (min)",
    "bookingStatusLabel": "Status",
    "bookingSourceLabel": "Booking source",
    "priceCents": "Price",
    "notes": "Notes",
    "firstName": "First name",
    "lastName": "Last name",
    "dob": "Birthday",
    "email": "Email",
    "phoneNumber": "Phone",
    "campaignsEmailSms": "E-mail and SMS campaigns",
    "bookingsCount": "Appointments",
    "cancellationsCount": "Cancellations",
    "totalBookingsValueCents": "Total appointments value",
    "templateLabel": "SMS type",
    "bookingDateInit": "Booking date",
    "messageParts": "SMS parts",
    "smsProviderLabel": "Provider",
    "deliveryStatusLabel": "Delivery status"
  }
}
